/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * Api
 * Contractor Estimator API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Attachment,
  BulkDeleteBody,
  BulkDeleteConflict,
  BulkDeleteResult,
  CalendarBillingEvent,
  CatalogItemUsage,
  CompanySettings,
  CreateAttachmentBody,
  CreateCustomerBody,
  CreateEstimateBody,
  CreateInternalCatalogBody,
  CreateInvoiceBody,
  CreateLineItemBody,
  CreateLineItemGroupBody,
  CreateMaterialBody,
  CreateProductBody,
  CreateProductDefaultCostBody,
  CreateTodoBody,
  Customer,
  DashboardSummary,
  DuplicateEstimate201,
  DuplicateInvoice201,
  ErrorEnvelope,
  Estimate,
  EstimateDetail,
  GetDashboardSummaryParams,
  GetEstimatesByStatusParams,
  GetInvoiceDashboardRevenueByCategoryParams,
  GetInvoiceDashboardSummaryParams,
  GetProfitPerEstimateParams,
  GetRecentEstimatesParams,
  HealthStatus,
  ImportFreeBuilderBody,
  ImportFreeBuilderResult,
  ImportResult,
  ImportRowsBody,
  InternalCatalogItem,
  Invoice,
  InvoiceAttachment,
  InvoiceDashboardSummary,
  InvoiceDetail,
  InvoiceLineItem,
  InvoiceLineItemGroup,
  InvoiceRevenueByCategoryItem,
  LineItem,
  LineItemGroup,
  ListActivityParams,
  ListActivityResponse,
  ListCalendarBillingEventsParams,
  ListCustomersParams,
  ListEstimatesParams,
  ListInvoicesParams,
  ListProductsParams,
  MarkDepositReceivedBody,
  Material,
  PatchTodoBody,
  Product,
  ProductDefaultCostItem,
  ProductUsage,
  ProfitPerEstimate,
  SaveServiceAgreementBody,
  StatusCount,
  TodoItem,
  UpdateEstimateBody,
  UpdateInvoiceBody,
  UpdateLineItemGroupBody,
  UpdateLineItemNoteBody,
  UpdateSettingsBody,
  UploadUrlRequest,
  UploadUrlResponse
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * @summary Liveness probe — succeeds as soon as the HTTP server is listening
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Liveness probe — succeeds as soon as the HTTP server is listening
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getReadinessCheckUrl = () => {




  return `/api/readyz`
}

/**
 * @summary Readiness probe — succeeds once startup tasks have finished and the database is reachable
 */
export const readinessCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getReadinessCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getReadinessCheckQueryKey = () => {
    return [
    `/api/readyz`
    ] as const;
    }


export const getReadinessCheckQueryOptions = <TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<HealthStatus>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getReadinessCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof readinessCheck>>> = ({ signal }) => readinessCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type ReadinessCheckQueryResult = NonNullable<Awaited<ReturnType<typeof readinessCheck>>>
export type ReadinessCheckQueryError = ErrorType<HealthStatus>


/**
 * @summary Readiness probe — succeeds once startup tasks have finished and the database is reachable
 */

export function useReadinessCheck<TData = Awaited<ReturnType<typeof readinessCheck>>, TError = ErrorType<HealthStatus>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getReadinessCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCustomersUrl = (params?: ListCustomersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/customers?${stringifiedParams}` : `/api/customers`
}

/**
 * @summary List all customers
 */
export const listCustomers = async (params?: ListCustomersParams, options?: RequestInit): Promise<Customer[]> => {

  return customFetch<Customer[]>(getListCustomersUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCustomersQueryKey = (params?: ListCustomersParams,) => {
    return [
    `/api/customers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCustomersQueryOptions = <TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCustomersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCustomers>>> = ({ signal }) => listCustomers(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof listCustomers>>>
export type ListCustomersQueryError = ErrorType<unknown>


/**
 * @summary List all customers
 */

export function useListCustomers<TData = Awaited<ReturnType<typeof listCustomers>>, TError = ErrorType<unknown>>(
 params?: ListCustomersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCustomers>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCustomerUrl = () => {




  return `/api/customers`
}

/**
 * @summary Create a customer
 */
export const createCustomer = async (createCustomerBody: CreateCustomerBody, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getCreateCustomerUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCustomerBody)
  }
);}




export const getCreateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerBody>}, TContext> => {

const mutationKey = ['createCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomer>>, {data: BodyType<CreateCustomerBody>}> = (props) => {
          const {data} = props ?? {};

          return  createCustomer(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomer>>>
    export type CreateCustomerMutationBody = BodyType<CreateCustomerBody>
    export type CreateCustomerMutationError = ErrorType<unknown>

    /**
 * @summary Create a customer
 */
export const useCreateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomer>>, TError,{data: BodyType<CreateCustomerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCustomer>>,
        TError,
        {data: BodyType<CreateCustomerBody>},
        TContext
      > => {
      return useMutation(getCreateCustomerMutationOptions(options));
    }

export const getBulkDeleteCustomersUrl = () => {




  return `/api/customers/bulk`
}

/**
 * @summary Bulk delete customers by IDs
 */
export const bulkDeleteCustomers = async (bulkDeleteBody: BulkDeleteBody, options?: RequestInit): Promise<BulkDeleteResult> => {

  return customFetch<BulkDeleteResult>(getBulkDeleteCustomersUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkDeleteBody)
  }
);}




export const getBulkDeleteCustomersMutationOptions = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCustomers>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCustomers>>, TError,{data: BodyType<BulkDeleteBody>}, TContext> => {

const mutationKey = ['bulkDeleteCustomers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteCustomers>>, {data: BodyType<BulkDeleteBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteCustomers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteCustomers>>>
    export type BulkDeleteCustomersMutationBody = BodyType<BulkDeleteBody>
    export type BulkDeleteCustomersMutationError = ErrorType<BulkDeleteConflict>

    /**
 * @summary Bulk delete customers by IDs
 */
export const useBulkDeleteCustomers = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteCustomers>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteCustomers>>,
        TError,
        {data: BodyType<BulkDeleteBody>},
        TContext
      > => {
      return useMutation(getBulkDeleteCustomersMutationOptions(options));
    }

export const getDeleteCustomerSavedCardUrl = (id: number,) => {




  return `/api/customers/${id}/saved-card`
}

/**
 * @summary Remove a customer's saved card
 */
export const deleteCustomerSavedCard = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerSavedCardUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerSavedCardMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerSavedCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerSavedCard>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomerSavedCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerSavedCard>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomerSavedCard(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerSavedCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerSavedCard>>>

    export type DeleteCustomerSavedCardMutationError = ErrorType<unknown>

    /**
 * @summary Remove a customer's saved card
 */
export const useDeleteCustomerSavedCard = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerSavedCard>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerSavedCard>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerSavedCardMutationOptions(options));
    }

export const getGetCustomerUrl = (id: number,) => {




  return `/api/customers/${id}`
}

/**
 * @summary Get a customer
 */
export const getCustomer = async (id: number, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getGetCustomerUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCustomerQueryKey = (id: number,) => {
    return [
    `/api/customers/${id}`
    ] as const;
    }


export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = ErrorType<unknown>


/**
 * @summary Get a customer
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetCustomerQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateCustomerUrl = (id: number,) => {




  return `/api/customers/${id}`
}

/**
 * @summary Update a customer
 */
export const updateCustomer = async (id: number,
    createCustomerBody: CreateCustomerBody, options?: RequestInit): Promise<Customer> => {

  return customFetch<Customer>(getUpdateCustomerUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createCustomerBody)
  }
);}




export const getUpdateCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CreateCustomerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CreateCustomerBody>}, TContext> => {

const mutationKey = ['updateCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomer>>, {id: number;data: BodyType<CreateCustomerBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateCustomer(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomer>>>
    export type UpdateCustomerMutationBody = BodyType<CreateCustomerBody>
    export type UpdateCustomerMutationError = ErrorType<unknown>

    /**
 * @summary Update a customer
 */
export const useUpdateCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomer>>, TError,{id: number;data: BodyType<CreateCustomerBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomer>>,
        TError,
        {id: number;data: BodyType<CreateCustomerBody>},
        TContext
      > => {
      return useMutation(getUpdateCustomerMutationOptions(options));
    }

export const getDeleteCustomerUrl = (id: number,) => {




  return `/api/customers/${id}`
}

/**
 * @summary Delete a customer
 */
export const deleteCustomer = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCustomerUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCustomerMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteCustomer'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomer>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteCustomer(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomer>>>

    export type DeleteCustomerMutationError = ErrorType<unknown>

    /**
 * @summary Delete a customer
 */
export const useDeleteCustomer = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomer>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomer>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteCustomerMutationOptions(options));
    }

export const getListEstimatesUrl = (params?: ListEstimatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/estimates?${stringifiedParams}` : `/api/estimates`
}

/**
 * @summary List all estimates
 */
export const listEstimates = async (params?: ListEstimatesParams, options?: RequestInit): Promise<Estimate[]> => {

  return customFetch<Estimate[]>(getListEstimatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListEstimatesQueryKey = (params?: ListEstimatesParams,) => {
    return [
    `/api/estimates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListEstimatesQueryOptions = <TData = Awaited<ReturnType<typeof listEstimates>>, TError = ErrorType<unknown>>(params?: ListEstimatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEstimates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListEstimatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listEstimates>>> = ({ signal }) => listEstimates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listEstimates>>, TError, TData> & { queryKey: QueryKey }
}

export type ListEstimatesQueryResult = NonNullable<Awaited<ReturnType<typeof listEstimates>>>
export type ListEstimatesQueryError = ErrorType<unknown>


/**
 * @summary List all estimates
 */

export function useListEstimates<TData = Awaited<ReturnType<typeof listEstimates>>, TError = ErrorType<unknown>>(
 params?: ListEstimatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listEstimates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListEstimatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateEstimateUrl = () => {




  return `/api/estimates`
}

/**
 * @summary Create an estimate
 */
export const createEstimate = async (createEstimateBody: CreateEstimateBody, options?: RequestInit): Promise<Estimate> => {

  return customFetch<Estimate>(getCreateEstimateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createEstimateBody)
  }
);}




export const getCreateEstimateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEstimate>>, TError,{data: BodyType<CreateEstimateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createEstimate>>, TError,{data: BodyType<CreateEstimateBody>}, TContext> => {

const mutationKey = ['createEstimate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createEstimate>>, {data: BodyType<CreateEstimateBody>}> = (props) => {
          const {data} = props ?? {};

          return  createEstimate(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof createEstimate>>>
    export type CreateEstimateMutationBody = BodyType<CreateEstimateBody>
    export type CreateEstimateMutationError = ErrorType<unknown>

    /**
 * @summary Create an estimate
 */
export const useCreateEstimate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createEstimate>>, TError,{data: BodyType<CreateEstimateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createEstimate>>,
        TError,
        {data: BodyType<CreateEstimateBody>},
        TContext
      > => {
      return useMutation(getCreateEstimateMutationOptions(options));
    }

export const getGetEstimateUrl = (id: number,) => {




  return `/api/estimates/${id}`
}

/**
 * @summary Get estimate with all details
 */
export const getEstimate = async (id: number, options?: RequestInit): Promise<EstimateDetail> => {

  return customFetch<EstimateDetail>(getGetEstimateUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEstimateQueryKey = (id: number,) => {
    return [
    `/api/estimates/${id}`
    ] as const;
    }


export const getGetEstimateQueryOptions = <TData = Awaited<ReturnType<typeof getEstimate>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEstimate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstimateQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstimate>>> = ({ signal }) => getEstimate(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstimate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEstimateQueryResult = NonNullable<Awaited<ReturnType<typeof getEstimate>>>
export type GetEstimateQueryError = ErrorType<unknown>


/**
 * @summary Get estimate with all details
 */

export function useGetEstimate<TData = Awaited<ReturnType<typeof getEstimate>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEstimate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEstimateQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateEstimateUrl = (id: number,) => {




  return `/api/estimates/${id}`
}

/**
 * @summary Update an estimate
 */
export const updateEstimate = async (id: number,
    updateEstimateBody: UpdateEstimateBody, options?: RequestInit): Promise<Estimate> => {

  return customFetch<Estimate>(getUpdateEstimateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateEstimateBody)
  }
);}




export const getUpdateEstimateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEstimate>>, TError,{id: number;data: BodyType<UpdateEstimateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateEstimate>>, TError,{id: number;data: BodyType<UpdateEstimateBody>}, TContext> => {

const mutationKey = ['updateEstimate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateEstimate>>, {id: number;data: BodyType<UpdateEstimateBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateEstimate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof updateEstimate>>>
    export type UpdateEstimateMutationBody = BodyType<UpdateEstimateBody>
    export type UpdateEstimateMutationError = ErrorType<unknown>

    /**
 * @summary Update an estimate
 */
export const useUpdateEstimate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateEstimate>>, TError,{id: number;data: BodyType<UpdateEstimateBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateEstimate>>,
        TError,
        {id: number;data: BodyType<UpdateEstimateBody>},
        TContext
      > => {
      return useMutation(getUpdateEstimateMutationOptions(options));
    }

export const getDeleteEstimateUrl = (id: number,) => {




  return `/api/estimates/${id}`
}

/**
 * @summary Delete an estimate
 */
export const deleteEstimate = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteEstimateUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteEstimateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstimate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEstimate>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteEstimate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEstimate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteEstimate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEstimate>>>

    export type DeleteEstimateMutationError = ErrorType<unknown>

    /**
 * @summary Delete an estimate
 */
export const useDeleteEstimate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEstimate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteEstimate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteEstimateMutationOptions(options));
    }

export const getListProductsUrl = (params?: ListProductsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/products?${stringifiedParams}` : `/api/products`
}

/**
 * @summary List all products/services
 */
export const listProducts = async (params?: ListProductsParams, options?: RequestInit): Promise<Product[]> => {

  return customFetch<Product[]>(getListProductsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductsQueryKey = (params?: ListProductsParams,) => {
    return [
    `/api/products`, ...(params ? [params] : [])
    ] as const;
    }


export const getListProductsQueryOptions = <TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProducts>>> = ({ signal }) => listProducts(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductsQueryResult = NonNullable<Awaited<ReturnType<typeof listProducts>>>
export type ListProductsQueryError = ErrorType<unknown>


/**
 * @summary List all products/services
 */

export function useListProducts<TData = Awaited<ReturnType<typeof listProducts>>, TError = ErrorType<unknown>>(
 params?: ListProductsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProducts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductUrl = () => {




  return `/api/products`
}

/**
 * @summary Create a product/service
 */
export const createProduct = async (createProductBody: CreateProductBody, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getCreateProductUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductBody)
  }
);}




export const getCreateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductBody>}, TContext> => {

const mutationKey = ['createProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProduct>>, {data: BodyType<CreateProductBody>}> = (props) => {
          const {data} = props ?? {};

          return  createProduct(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductMutationResult = NonNullable<Awaited<ReturnType<typeof createProduct>>>
    export type CreateProductMutationBody = BodyType<CreateProductBody>
    export type CreateProductMutationError = ErrorType<unknown>

    /**
 * @summary Create a product/service
 */
export const useCreateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProduct>>, TError,{data: BodyType<CreateProductBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProduct>>,
        TError,
        {data: BodyType<CreateProductBody>},
        TContext
      > => {
      return useMutation(getCreateProductMutationOptions(options));
    }

export const getBulkDeleteProductsUrl = () => {




  return `/api/products/bulk`
}

/**
 * @summary Bulk delete products by IDs
 */
export const bulkDeleteProducts = async (bulkDeleteBody: BulkDeleteBody, options?: RequestInit): Promise<BulkDeleteResult> => {

  return customFetch<BulkDeleteResult>(getBulkDeleteProductsUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkDeleteBody)
  }
);}




export const getBulkDeleteProductsMutationOptions = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteProducts>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteProducts>>, TError,{data: BodyType<BulkDeleteBody>}, TContext> => {

const mutationKey = ['bulkDeleteProducts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteProducts>>, {data: BodyType<BulkDeleteBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteProducts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteProductsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteProducts>>>
    export type BulkDeleteProductsMutationBody = BodyType<BulkDeleteBody>
    export type BulkDeleteProductsMutationError = ErrorType<BulkDeleteConflict>

    /**
 * @summary Bulk delete products by IDs
 */
export const useBulkDeleteProducts = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteProducts>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteProducts>>,
        TError,
        {data: BodyType<BulkDeleteBody>},
        TContext
      > => {
      return useMutation(getBulkDeleteProductsMutationOptions(options));
    }

export const getGetProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Get a single product
 */
export const getProduct = async (id: number, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getGetProductUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductQueryKey = (id: number,) => {
    return [
    `/api/products/${id}`
    ] as const;
    }


export const getGetProductQueryOptions = <TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProduct>>> = ({ signal }) => getProduct(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductQueryResult = NonNullable<Awaited<ReturnType<typeof getProduct>>>
export type GetProductQueryError = ErrorType<unknown>


/**
 * @summary Get a single product
 */

export function useGetProduct<TData = Awaited<ReturnType<typeof getProduct>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProduct>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Update a product
 */
export const updateProduct = async (id: number,
    createProductBody: CreateProductBody, options?: RequestInit): Promise<Product> => {

  return customFetch<Product>(getUpdateProductUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductBody)
  }
);}




export const getUpdateProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<CreateProductBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<CreateProductBody>}, TContext> => {

const mutationKey = ['updateProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProduct>>, {id: number;data: BodyType<CreateProductBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateProduct(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductMutationResult = NonNullable<Awaited<ReturnType<typeof updateProduct>>>
    export type UpdateProductMutationBody = BodyType<CreateProductBody>
    export type UpdateProductMutationError = ErrorType<unknown>

    /**
 * @summary Update a product
 */
export const useUpdateProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProduct>>, TError,{id: number;data: BodyType<CreateProductBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProduct>>,
        TError,
        {id: number;data: BodyType<CreateProductBody>},
        TContext
      > => {
      return useMutation(getUpdateProductMutationOptions(options));
    }

export const getDeleteProductUrl = (id: number,) => {




  return `/api/products/${id}`
}

/**
 * @summary Delete a product
 */
export const deleteProduct = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteProduct'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProduct>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteProduct(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProduct>>>

    export type DeleteProductMutationError = ErrorType<unknown>

    /**
 * @summary Delete a product
 */
export const useDeleteProduct = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProduct>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProduct>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteProductMutationOptions(options));
    }

export const getGetProductUsageUrl = (id: number,) => {




  return `/api/products/${id}/usage`
}

/**
 * @summary Get product usage across estimates
 */
export const getProductUsage = async (id: number, options?: RequestInit): Promise<ProductUsage> => {

  return customFetch<ProductUsage>(getGetProductUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductUsageQueryKey = (id: number,) => {
    return [
    `/api/products/${id}/usage`
    ] as const;
    }


export const getGetProductUsageQueryOptions = <TData = Awaited<ReturnType<typeof getProductUsage>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductUsage>>> = ({ signal }) => getProductUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProductUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getProductUsage>>>
export type GetProductUsageQueryError = ErrorType<void>


/**
 * @summary Get product usage across estimates
 */

export function useGetProductUsage<TData = Awaited<ReturnType<typeof getProductUsage>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProductUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProductUsageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListProductDefaultCostsUrl = (productId: number,) => {




  return `/api/products/${productId}/costs`
}

/**
 * @summary List default costs for a product
 */
export const listProductDefaultCosts = async (productId: number, options?: RequestInit): Promise<ProductDefaultCostItem[]> => {

  return customFetch<ProductDefaultCostItem[]>(getListProductDefaultCostsUrl(productId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListProductDefaultCostsQueryKey = (productId: number,) => {
    return [
    `/api/products/${productId}/costs`
    ] as const;
    }


export const getListProductDefaultCostsQueryOptions = <TData = Awaited<ReturnType<typeof listProductDefaultCosts>>, TError = ErrorType<void>>(productId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductDefaultCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListProductDefaultCostsQueryKey(productId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProductDefaultCosts>>> = ({ signal }) => listProductDefaultCosts(productId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: productId !== null && productId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProductDefaultCosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListProductDefaultCostsQueryResult = NonNullable<Awaited<ReturnType<typeof listProductDefaultCosts>>>
export type ListProductDefaultCostsQueryError = ErrorType<void>


/**
 * @summary List default costs for a product
 */

export function useListProductDefaultCosts<TData = Awaited<ReturnType<typeof listProductDefaultCosts>>, TError = ErrorType<void>>(
 productId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listProductDefaultCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListProductDefaultCostsQueryOptions(productId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateProductDefaultCostUrl = (productId: number,) => {




  return `/api/products/${productId}/costs`
}

/**
 * @summary Add a default cost to a product
 */
export const createProductDefaultCost = async (productId: number,
    createProductDefaultCostBody: CreateProductDefaultCostBody, options?: RequestInit): Promise<ProductDefaultCostItem> => {

  return customFetch<ProductDefaultCostItem>(getCreateProductDefaultCostUrl(productId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductDefaultCostBody)
  }
);}




export const getCreateProductDefaultCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductDefaultCost>>, TError,{productId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProductDefaultCost>>, TError,{productId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext> => {

const mutationKey = ['createProductDefaultCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProductDefaultCost>>, {productId: number;data: BodyType<CreateProductDefaultCostBody>}> = (props) => {
          const {productId,data} = props ?? {};

          return  createProductDefaultCost(productId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateProductDefaultCostMutationResult = NonNullable<Awaited<ReturnType<typeof createProductDefaultCost>>>
    export type CreateProductDefaultCostMutationBody = BodyType<CreateProductDefaultCostBody>
    export type CreateProductDefaultCostMutationError = ErrorType<unknown>

    /**
 * @summary Add a default cost to a product
 */
export const useCreateProductDefaultCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProductDefaultCost>>, TError,{productId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createProductDefaultCost>>,
        TError,
        {productId: number;data: BodyType<CreateProductDefaultCostBody>},
        TContext
      > => {
      return useMutation(getCreateProductDefaultCostMutationOptions(options));
    }

export const getUpdateProductDefaultCostUrl = (productId: number,
    costId: number,) => {




  return `/api/products/${productId}/costs/${costId}`
}

/**
 * @summary Update a default cost on a product
 */
export const updateProductDefaultCost = async (productId: number,
    costId: number,
    createProductDefaultCostBody: CreateProductDefaultCostBody, options?: RequestInit): Promise<ProductDefaultCostItem> => {

  return customFetch<ProductDefaultCostItem>(getUpdateProductDefaultCostUrl(productId,costId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createProductDefaultCostBody)
  }
);}




export const getUpdateProductDefaultCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductDefaultCost>>, TError,{productId: number;costId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProductDefaultCost>>, TError,{productId: number;costId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext> => {

const mutationKey = ['updateProductDefaultCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProductDefaultCost>>, {productId: number;costId: number;data: BodyType<CreateProductDefaultCostBody>}> = (props) => {
          const {productId,costId,data} = props ?? {};

          return  updateProductDefaultCost(productId,costId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateProductDefaultCostMutationResult = NonNullable<Awaited<ReturnType<typeof updateProductDefaultCost>>>
    export type UpdateProductDefaultCostMutationBody = BodyType<CreateProductDefaultCostBody>
    export type UpdateProductDefaultCostMutationError = ErrorType<unknown>

    /**
 * @summary Update a default cost on a product
 */
export const useUpdateProductDefaultCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProductDefaultCost>>, TError,{productId: number;costId: number;data: BodyType<CreateProductDefaultCostBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateProductDefaultCost>>,
        TError,
        {productId: number;costId: number;data: BodyType<CreateProductDefaultCostBody>},
        TContext
      > => {
      return useMutation(getUpdateProductDefaultCostMutationOptions(options));
    }

export const getDeleteProductDefaultCostUrl = (productId: number,
    costId: number,) => {




  return `/api/products/${productId}/costs/${costId}`
}

/**
 * @summary Delete a default cost from a product
 */
export const deleteProductDefaultCost = async (productId: number,
    costId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteProductDefaultCostUrl(productId,costId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteProductDefaultCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductDefaultCost>>, TError,{productId: number;costId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProductDefaultCost>>, TError,{productId: number;costId: number}, TContext> => {

const mutationKey = ['deleteProductDefaultCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProductDefaultCost>>, {productId: number;costId: number}> = (props) => {
          const {productId,costId} = props ?? {};

          return  deleteProductDefaultCost(productId,costId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteProductDefaultCostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProductDefaultCost>>>

    export type DeleteProductDefaultCostMutationError = ErrorType<unknown>

    /**
 * @summary Delete a default cost from a product
 */
export const useDeleteProductDefaultCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProductDefaultCost>>, TError,{productId: number;costId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteProductDefaultCost>>,
        TError,
        {productId: number;costId: number},
        TContext
      > => {
      return useMutation(getDeleteProductDefaultCostMutationOptions(options));
    }

export const getGetInternalCatalogItemUsageUrl = (id: number,) => {




  return `/api/internal-catalog/${id}/usage`
}

/**
 * @summary Get internal catalog item usage across estimates
 */
export const getInternalCatalogItemUsage = async (id: number, options?: RequestInit): Promise<CatalogItemUsage> => {

  return customFetch<CatalogItemUsage>(getGetInternalCatalogItemUsageUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInternalCatalogItemUsageQueryKey = (id: number,) => {
    return [
    `/api/internal-catalog/${id}/usage`
    ] as const;
    }


export const getGetInternalCatalogItemUsageQueryOptions = <TData = Awaited<ReturnType<typeof getInternalCatalogItemUsage>>, TError = ErrorType<void>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInternalCatalogItemUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInternalCatalogItemUsageQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInternalCatalogItemUsage>>> = ({ signal }) => getInternalCatalogItemUsage(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInternalCatalogItemUsage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInternalCatalogItemUsageQueryResult = NonNullable<Awaited<ReturnType<typeof getInternalCatalogItemUsage>>>
export type GetInternalCatalogItemUsageQueryError = ErrorType<void>


/**
 * @summary Get internal catalog item usage across estimates
 */

export function useGetInternalCatalogItemUsage<TData = Awaited<ReturnType<typeof getInternalCatalogItemUsage>>, TError = ErrorType<void>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInternalCatalogItemUsage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInternalCatalogItemUsageQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListLineItemsUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/line-items`
}

/**
 * @summary List line items for an estimate
 */
export const listLineItems = async (estimateId: number, options?: RequestInit): Promise<LineItem[]> => {

  return customFetch<LineItem[]>(getListLineItemsUrl(estimateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLineItemsQueryKey = (estimateId: number,) => {
    return [
    `/api/estimates/${estimateId}/line-items`
    ] as const;
    }


export const getListLineItemsQueryOptions = <TData = Awaited<ReturnType<typeof listLineItems>>, TError = ErrorType<unknown>>(estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLineItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLineItemsQueryKey(estimateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLineItems>>> = ({ signal }) => listLineItems(estimateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: estimateId !== null && estimateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLineItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLineItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listLineItems>>>
export type ListLineItemsQueryError = ErrorType<unknown>


/**
 * @summary List line items for an estimate
 */

export function useListLineItems<TData = Awaited<ReturnType<typeof listLineItems>>, TError = ErrorType<unknown>>(
 estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLineItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLineItemsQueryOptions(estimateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLineItemUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/line-items`
}

/**
 * @summary Add a line item
 */
export const createLineItem = async (estimateId: number,
    createLineItemBody: CreateLineItemBody, options?: RequestInit): Promise<LineItem> => {

  return customFetch<LineItem>(getCreateLineItemUrl(estimateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemBody)
  }
);}




export const getCreateLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLineItem>>, TError,{estimateId: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLineItem>>, TError,{estimateId: number;data: BodyType<CreateLineItemBody>}, TContext> => {

const mutationKey = ['createLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLineItem>>, {estimateId: number;data: BodyType<CreateLineItemBody>}> = (props) => {
          const {estimateId,data} = props ?? {};

          return  createLineItem(estimateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof createLineItem>>>
    export type CreateLineItemMutationBody = BodyType<CreateLineItemBody>
    export type CreateLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Add a line item
 */
export const useCreateLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLineItem>>, TError,{estimateId: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLineItem>>,
        TError,
        {estimateId: number;data: BodyType<CreateLineItemBody>},
        TContext
      > => {
      return useMutation(getCreateLineItemMutationOptions(options));
    }

export const getUpdateLineItemUrl = (estimateId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/line-items/${id}`
}

/**
 * @summary Update a line item
 */
export const updateLineItem = async (estimateId: number,
    id: number,
    createLineItemBody: CreateLineItemBody, options?: RequestInit): Promise<LineItem> => {

  return customFetch<LineItem>(getUpdateLineItemUrl(estimateId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemBody)
  }
);}




export const getUpdateLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItem>>, TError,{estimateId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLineItem>>, TError,{estimateId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext> => {

const mutationKey = ['updateLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLineItem>>, {estimateId: number;id: number;data: BodyType<CreateLineItemBody>}> = (props) => {
          const {estimateId,id,data} = props ?? {};

          return  updateLineItem(estimateId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateLineItem>>>
    export type UpdateLineItemMutationBody = BodyType<CreateLineItemBody>
    export type UpdateLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Update a line item
 */
export const useUpdateLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItem>>, TError,{estimateId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLineItem>>,
        TError,
        {estimateId: number;id: number;data: BodyType<CreateLineItemBody>},
        TContext
      > => {
      return useMutation(getUpdateLineItemMutationOptions(options));
    }

export const getDeleteLineItemUrl = (estimateId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/line-items/${id}`
}

/**
 * @summary Delete a line item
 */
export const deleteLineItem = async (estimateId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLineItemUrl(estimateId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLineItem>>, TError,{estimateId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLineItem>>, TError,{estimateId: number;id: number}, TContext> => {

const mutationKey = ['deleteLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLineItem>>, {estimateId: number;id: number}> = (props) => {
          const {estimateId,id} = props ?? {};

          return  deleteLineItem(estimateId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLineItem>>>

    export type DeleteLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete a line item
 */
export const useDeleteLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLineItem>>, TError,{estimateId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLineItem>>,
        TError,
        {estimateId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteLineItemMutationOptions(options));
    }

export const getListCostsUrl = (estimateId: number,
    lineItemId: number,) => {




  return `/api/estimates/${estimateId}/line-items/${lineItemId}/costs`
}

/**
 * @summary List internal costs for a line item
 */
export const listCosts = async (estimateId: number,
    lineItemId: number, options?: RequestInit): Promise<Material[]> => {

  return customFetch<Material[]>(getListCostsUrl(estimateId,lineItemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCostsQueryKey = (estimateId: number,
    lineItemId: number,) => {
    return [
    `/api/estimates/${estimateId}/line-items/${lineItemId}/costs`
    ] as const;
    }


export const getListCostsQueryOptions = <TData = Awaited<ReturnType<typeof listCosts>>, TError = ErrorType<unknown>>(estimateId: number,
    lineItemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCostsQueryKey(estimateId,lineItemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCosts>>> = ({ signal }) => listCosts(estimateId,lineItemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: estimateId !== null && estimateId !== undefined && lineItemId !== null && lineItemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCostsQueryResult = NonNullable<Awaited<ReturnType<typeof listCosts>>>
export type ListCostsQueryError = ErrorType<unknown>


/**
 * @summary List internal costs for a line item
 */

export function useListCosts<TData = Awaited<ReturnType<typeof listCosts>>, TError = ErrorType<unknown>>(
 estimateId: number,
    lineItemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCostsQueryOptions(estimateId,lineItemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateCostUrl = (estimateId: number,
    lineItemId: number,) => {




  return `/api/estimates/${estimateId}/line-items/${lineItemId}/costs`
}

/**
 * @summary Add an internal cost to a line item
 */
export const createCost = async (estimateId: number,
    lineItemId: number,
    createMaterialBody: CreateMaterialBody, options?: RequestInit): Promise<Material> => {

  return customFetch<Material>(getCreateCostUrl(estimateId,lineItemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMaterialBody)
  }
);}




export const getCreateCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCost>>, TError,{estimateId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCost>>, TError,{estimateId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext> => {

const mutationKey = ['createCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCost>>, {estimateId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}> = (props) => {
          const {estimateId,lineItemId,data} = props ?? {};

          return  createCost(estimateId,lineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCostMutationResult = NonNullable<Awaited<ReturnType<typeof createCost>>>
    export type CreateCostMutationBody = BodyType<CreateMaterialBody>
    export type CreateCostMutationError = ErrorType<unknown>

    /**
 * @summary Add an internal cost to a line item
 */
export const useCreateCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCost>>, TError,{estimateId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCost>>,
        TError,
        {estimateId: number;lineItemId: number;data: BodyType<CreateMaterialBody>},
        TContext
      > => {
      return useMutation(getCreateCostMutationOptions(options));
    }

export const getUpdateCostUrl = (estimateId: number,
    lineItemId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/line-items/${lineItemId}/costs/${id}`
}

/**
 * @summary Update an internal cost
 */
export const updateCost = async (estimateId: number,
    lineItemId: number,
    id: number,
    createMaterialBody: CreateMaterialBody, options?: RequestInit): Promise<Material> => {

  return customFetch<Material>(getUpdateCostUrl(estimateId,lineItemId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMaterialBody)
  }
);}




export const getUpdateCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCost>>, TError,{estimateId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCost>>, TError,{estimateId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext> => {

const mutationKey = ['updateCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCost>>, {estimateId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}> = (props) => {
          const {estimateId,lineItemId,id,data} = props ?? {};

          return  updateCost(estimateId,lineItemId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateCostMutationResult = NonNullable<Awaited<ReturnType<typeof updateCost>>>
    export type UpdateCostMutationBody = BodyType<CreateMaterialBody>
    export type UpdateCostMutationError = ErrorType<unknown>

    /**
 * @summary Update an internal cost
 */
export const useUpdateCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCost>>, TError,{estimateId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCost>>,
        TError,
        {estimateId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>},
        TContext
      > => {
      return useMutation(getUpdateCostMutationOptions(options));
    }

export const getDeleteCostUrl = (estimateId: number,
    lineItemId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/line-items/${lineItemId}/costs/${id}`
}

/**
 * @summary Delete an internal cost
 */
export const deleteCost = async (estimateId: number,
    lineItemId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteCostUrl(estimateId,lineItemId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCost>>, TError,{estimateId: number;lineItemId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCost>>, TError,{estimateId: number;lineItemId: number;id: number}, TContext> => {

const mutationKey = ['deleteCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCost>>, {estimateId: number;lineItemId: number;id: number}> = (props) => {
          const {estimateId,lineItemId,id} = props ?? {};

          return  deleteCost(estimateId,lineItemId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteCostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCost>>>

    export type DeleteCostMutationError = ErrorType<unknown>

    /**
 * @summary Delete an internal cost
 */
export const useDeleteCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCost>>, TError,{estimateId: number;lineItemId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCost>>,
        TError,
        {estimateId: number;lineItemId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteCostMutationOptions(options));
    }

export const getUpdateLineItemNoteUrl = (estimateId: number,
    lineItemId: number,) => {




  return `/api/estimates/${estimateId}/line-items/${lineItemId}/note`
}

/**
 * @summary Set or clear the private note on a line item
 */
export const updateLineItemNote = async (estimateId: number,
    lineItemId: number,
    updateLineItemNoteBody: UpdateLineItemNoteBody, options?: RequestInit): Promise<LineItem> => {

  return customFetch<LineItem>(getUpdateLineItemNoteUrl(estimateId,lineItemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLineItemNoteBody)
  }
);}




export const getUpdateLineItemNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItemNote>>, TError,{estimateId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLineItemNote>>, TError,{estimateId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext> => {

const mutationKey = ['updateLineItemNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLineItemNote>>, {estimateId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}> = (props) => {
          const {estimateId,lineItemId,data} = props ?? {};

          return  updateLineItemNote(estimateId,lineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLineItemNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateLineItemNote>>>
    export type UpdateLineItemNoteMutationBody = BodyType<UpdateLineItemNoteBody>
    export type UpdateLineItemNoteMutationError = ErrorType<unknown>

    /**
 * @summary Set or clear the private note on a line item
 */
export const useUpdateLineItemNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItemNote>>, TError,{estimateId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLineItemNote>>,
        TError,
        {estimateId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>},
        TContext
      > => {
      return useMutation(getUpdateLineItemNoteMutationOptions(options));
    }

export const getListLineItemGroupsUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/groups`
}

/**
 * @summary List line item groups for an estimate
 */
export const listLineItemGroups = async (estimateId: number, options?: RequestInit): Promise<LineItemGroup[]> => {

  return customFetch<LineItemGroup[]>(getListLineItemGroupsUrl(estimateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLineItemGroupsQueryKey = (estimateId: number,) => {
    return [
    `/api/estimates/${estimateId}/groups`
    ] as const;
    }


export const getListLineItemGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listLineItemGroups>>, TError = ErrorType<unknown>>(estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLineItemGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLineItemGroupsQueryKey(estimateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLineItemGroups>>> = ({ signal }) => listLineItemGroups(estimateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: estimateId !== null && estimateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLineItemGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListLineItemGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listLineItemGroups>>>
export type ListLineItemGroupsQueryError = ErrorType<unknown>


/**
 * @summary List line item groups for an estimate
 */

export function useListLineItemGroups<TData = Awaited<ReturnType<typeof listLineItemGroups>>, TError = ErrorType<unknown>>(
 estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listLineItemGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListLineItemGroupsQueryOptions(estimateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateLineItemGroupUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/groups`
}

/**
 * @summary Create a new line item group
 */
export const createLineItemGroup = async (estimateId: number,
    createLineItemGroupBody: CreateLineItemGroupBody, options?: RequestInit): Promise<LineItemGroup> => {

  return customFetch<LineItemGroup>(getCreateLineItemGroupUrl(estimateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemGroupBody)
  }
);}




export const getCreateLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLineItemGroup>>, TError,{estimateId: number;data: BodyType<CreateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLineItemGroup>>, TError,{estimateId: number;data: BodyType<CreateLineItemGroupBody>}, TContext> => {

const mutationKey = ['createLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLineItemGroup>>, {estimateId: number;data: BodyType<CreateLineItemGroupBody>}> = (props) => {
          const {estimateId,data} = props ?? {};

          return  createLineItemGroup(estimateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createLineItemGroup>>>
    export type CreateLineItemGroupMutationBody = BodyType<CreateLineItemGroupBody>
    export type CreateLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Create a new line item group
 */
export const useCreateLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLineItemGroup>>, TError,{estimateId: number;data: BodyType<CreateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createLineItemGroup>>,
        TError,
        {estimateId: number;data: BodyType<CreateLineItemGroupBody>},
        TContext
      > => {
      return useMutation(getCreateLineItemGroupMutationOptions(options));
    }

export const getUpdateLineItemGroupUrl = (estimateId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/groups/${id}`
}

/**
 * @summary Update a line item group
 */
export const updateLineItemGroup = async (estimateId: number,
    id: number,
    updateLineItemGroupBody: UpdateLineItemGroupBody, options?: RequestInit): Promise<LineItemGroup> => {

  return customFetch<LineItemGroup>(getUpdateLineItemGroupUrl(estimateId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLineItemGroupBody)
  }
);}




export const getUpdateLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItemGroup>>, TError,{estimateId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLineItemGroup>>, TError,{estimateId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext> => {

const mutationKey = ['updateLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLineItemGroup>>, {estimateId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}> = (props) => {
          const {estimateId,id,data} = props ?? {};

          return  updateLineItemGroup(estimateId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateLineItemGroup>>>
    export type UpdateLineItemGroupMutationBody = BodyType<UpdateLineItemGroupBody>
    export type UpdateLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Update a line item group
 */
export const useUpdateLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLineItemGroup>>, TError,{estimateId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateLineItemGroup>>,
        TError,
        {estimateId: number;id: number;data: BodyType<UpdateLineItemGroupBody>},
        TContext
      > => {
      return useMutation(getUpdateLineItemGroupMutationOptions(options));
    }

export const getDeleteLineItemGroupUrl = (estimateId: number,
    id: number,) => {




  return `/api/estimates/${estimateId}/groups/${id}`
}

/**
 * @summary Delete a line item group (ungrouping its items)
 */
export const deleteLineItemGroup = async (estimateId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteLineItemGroupUrl(estimateId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLineItemGroup>>, TError,{estimateId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLineItemGroup>>, TError,{estimateId: number;id: number}, TContext> => {

const mutationKey = ['deleteLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLineItemGroup>>, {estimateId: number;id: number}> = (props) => {
          const {estimateId,id} = props ?? {};

          return  deleteLineItemGroup(estimateId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLineItemGroup>>>

    export type DeleteLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Delete a line item group (ungrouping its items)
 */
export const useDeleteLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLineItemGroup>>, TError,{estimateId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteLineItemGroup>>,
        TError,
        {estimateId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteLineItemGroupMutationOptions(options));
    }

export const getListInternalCatalogUrl = () => {




  return `/api/internal-catalog`
}

/**
 * @summary List all internal catalog items
 */
export const listInternalCatalog = async ( options?: RequestInit): Promise<InternalCatalogItem[]> => {

  return customFetch<InternalCatalogItem[]>(getListInternalCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInternalCatalogQueryKey = () => {
    return [
    `/api/internal-catalog`
    ] as const;
    }


export const getListInternalCatalogQueryOptions = <TData = Awaited<ReturnType<typeof listInternalCatalog>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInternalCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInternalCatalogQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInternalCatalog>>> = ({ signal }) => listInternalCatalog({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInternalCatalog>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInternalCatalogQueryResult = NonNullable<Awaited<ReturnType<typeof listInternalCatalog>>>
export type ListInternalCatalogQueryError = ErrorType<unknown>


/**
 * @summary List all internal catalog items
 */

export function useListInternalCatalog<TData = Awaited<ReturnType<typeof listInternalCatalog>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInternalCatalog>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInternalCatalogQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInternalCatalogItemUrl = () => {




  return `/api/internal-catalog`
}

/**
 * @summary Create a new internal catalog item
 */
export const createInternalCatalogItem = async (createInternalCatalogBody: CreateInternalCatalogBody, options?: RequestInit): Promise<InternalCatalogItem> => {

  return customFetch<InternalCatalogItem>(getCreateInternalCatalogItemUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInternalCatalogBody)
  }
);}




export const getCreateInternalCatalogItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalCatalogItem>>, TError,{data: BodyType<CreateInternalCatalogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInternalCatalogItem>>, TError,{data: BodyType<CreateInternalCatalogBody>}, TContext> => {

const mutationKey = ['createInternalCatalogItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInternalCatalogItem>>, {data: BodyType<CreateInternalCatalogBody>}> = (props) => {
          const {data} = props ?? {};

          return  createInternalCatalogItem(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInternalCatalogItemMutationResult = NonNullable<Awaited<ReturnType<typeof createInternalCatalogItem>>>
    export type CreateInternalCatalogItemMutationBody = BodyType<CreateInternalCatalogBody>
    export type CreateInternalCatalogItemMutationError = ErrorType<unknown>

    /**
 * @summary Create a new internal catalog item
 */
export const useCreateInternalCatalogItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInternalCatalogItem>>, TError,{data: BodyType<CreateInternalCatalogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInternalCatalogItem>>,
        TError,
        {data: BodyType<CreateInternalCatalogBody>},
        TContext
      > => {
      return useMutation(getCreateInternalCatalogItemMutationOptions(options));
    }

export const getBulkDeleteInternalCatalogItemsUrl = () => {




  return `/api/internal-catalog/bulk`
}

/**
 * @summary Bulk delete internal catalog items by IDs
 */
export const bulkDeleteInternalCatalogItems = async (bulkDeleteBody: BulkDeleteBody, options?: RequestInit): Promise<BulkDeleteResult> => {

  return customFetch<BulkDeleteResult>(getBulkDeleteInternalCatalogItemsUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(bulkDeleteBody)
  }
);}




export const getBulkDeleteInternalCatalogItemsMutationOptions = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>, TError,{data: BodyType<BulkDeleteBody>}, TContext> => {

const mutationKey = ['bulkDeleteInternalCatalogItems'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>, {data: BodyType<BulkDeleteBody>}> = (props) => {
          const {data} = props ?? {};

          return  bulkDeleteInternalCatalogItems(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type BulkDeleteInternalCatalogItemsMutationResult = NonNullable<Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>>
    export type BulkDeleteInternalCatalogItemsMutationBody = BodyType<BulkDeleteBody>
    export type BulkDeleteInternalCatalogItemsMutationError = ErrorType<BulkDeleteConflict>

    /**
 * @summary Bulk delete internal catalog items by IDs
 */
export const useBulkDeleteInternalCatalogItems = <TError = ErrorType<BulkDeleteConflict>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>, TError,{data: BodyType<BulkDeleteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof bulkDeleteInternalCatalogItems>>,
        TError,
        {data: BodyType<BulkDeleteBody>},
        TContext
      > => {
      return useMutation(getBulkDeleteInternalCatalogItemsMutationOptions(options));
    }

export const getUpdateInternalCatalogItemUrl = (id: number,) => {




  return `/api/internal-catalog/${id}`
}

/**
 * @summary Update an internal catalog item
 */
export const updateInternalCatalogItem = async (id: number,
    createInternalCatalogBody: CreateInternalCatalogBody, options?: RequestInit): Promise<InternalCatalogItem> => {

  return customFetch<InternalCatalogItem>(getUpdateInternalCatalogItemUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInternalCatalogBody)
  }
);}




export const getUpdateInternalCatalogItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalCatalogItem>>, TError,{id: number;data: BodyType<CreateInternalCatalogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInternalCatalogItem>>, TError,{id: number;data: BodyType<CreateInternalCatalogBody>}, TContext> => {

const mutationKey = ['updateInternalCatalogItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInternalCatalogItem>>, {id: number;data: BodyType<CreateInternalCatalogBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInternalCatalogItem(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInternalCatalogItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateInternalCatalogItem>>>
    export type UpdateInternalCatalogItemMutationBody = BodyType<CreateInternalCatalogBody>
    export type UpdateInternalCatalogItemMutationError = ErrorType<unknown>

    /**
 * @summary Update an internal catalog item
 */
export const useUpdateInternalCatalogItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInternalCatalogItem>>, TError,{id: number;data: BodyType<CreateInternalCatalogBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInternalCatalogItem>>,
        TError,
        {id: number;data: BodyType<CreateInternalCatalogBody>},
        TContext
      > => {
      return useMutation(getUpdateInternalCatalogItemMutationOptions(options));
    }

export const getDeleteInternalCatalogItemUrl = (id: number,) => {




  return `/api/internal-catalog/${id}`
}

/**
 * @summary Delete an internal catalog item
 */
export const deleteInternalCatalogItem = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInternalCatalogItemUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInternalCatalogItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCatalogItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCatalogItem>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteInternalCatalogItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInternalCatalogItem>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteInternalCatalogItem(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInternalCatalogItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInternalCatalogItem>>>

    export type DeleteInternalCatalogItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete an internal catalog item
 */
export const useDeleteInternalCatalogItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInternalCatalogItem>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInternalCatalogItem>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteInternalCatalogItemMutationOptions(options));
    }

export const getGetDashboardSummaryUrl = (params?: GetDashboardSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/summary?${stringifiedParams}` : `/api/dashboard/summary`
}

/**
 * @summary Get dashboard summary stats
 */
export const getDashboardSummary = async (params?: GetDashboardSummaryParams, options?: RequestInit): Promise<DashboardSummary> => {

  return customFetch<DashboardSummary>(getGetDashboardSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDashboardSummaryQueryKey = (params?: GetDashboardSummaryParams,) => {
    return [
    `/api/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDashboardSummary>>> = ({ signal }) => getDashboardSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getDashboardSummary>>>
export type GetDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get dashboard summary stats
 */

export function useGetDashboardSummary<TData = Awaited<ReturnType<typeof getDashboardSummary>>, TError = ErrorType<unknown>>(
 params?: GetDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetRecentEstimatesUrl = (params?: GetRecentEstimatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/recent-estimates?${stringifiedParams}` : `/api/dashboard/recent-estimates`
}

/**
 * @summary Get recent estimates
 */
export const getRecentEstimates = async (params?: GetRecentEstimatesParams, options?: RequestInit): Promise<Estimate[]> => {

  return customFetch<Estimate[]>(getGetRecentEstimatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRecentEstimatesQueryKey = (params?: GetRecentEstimatesParams,) => {
    return [
    `/api/dashboard/recent-estimates`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetRecentEstimatesQueryOptions = <TData = Awaited<ReturnType<typeof getRecentEstimates>>, TError = ErrorType<unknown>>(params?: GetRecentEstimatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentEstimates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentEstimatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentEstimates>>> = ({ signal }) => getRecentEstimates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentEstimates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentEstimatesQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentEstimates>>>
export type GetRecentEstimatesQueryError = ErrorType<unknown>


/**
 * @summary Get recent estimates
 */

export function useGetRecentEstimates<TData = Awaited<ReturnType<typeof getRecentEstimates>>, TError = ErrorType<unknown>>(
 params?: GetRecentEstimatesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentEstimates>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRecentEstimatesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListActivityUrl = (params?: ListActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/activity?${stringifiedParams}` : `/api/activity`
}

/**
 * @summary List recent account activity events (last 90 days)
 */
export const listActivity = async (params?: ListActivityParams, options?: RequestInit): Promise<ListActivityResponse> => {

  return customFetch<ListActivityResponse>(getListActivityUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListActivityQueryKey = (params?: ListActivityParams,) => {
    return [
    `/api/activity`, ...(params ? [params] : [])
    ] as const;
    }


export const getListActivityQueryOptions = <TData = Awaited<ReturnType<typeof listActivity>>, TError = ErrorType<void>>(params?: ListActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListActivityQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listActivity>>> = ({ signal }) => listActivity(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listActivity>>, TError, TData> & { queryKey: QueryKey }
}

export type ListActivityQueryResult = NonNullable<Awaited<ReturnType<typeof listActivity>>>
export type ListActivityQueryError = ErrorType<void>


/**
 * @summary List recent account activity events (last 90 days)
 */

export function useListActivity<TData = Awaited<ReturnType<typeof listActivity>>, TError = ErrorType<void>>(
 params?: ListActivityParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listActivity>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListActivityQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListCalendarBillingEventsUrl = (params: ListCalendarBillingEventsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/calendar/billing-events?${stringifiedParams}` : `/api/calendar/billing-events`
}

/**
 * @summary List billing events (quote expirations, invoice due/paid/recurring dates) within a date range
 */
export const listCalendarBillingEvents = async (params: ListCalendarBillingEventsParams, options?: RequestInit): Promise<CalendarBillingEvent[]> => {

  return customFetch<CalendarBillingEvent[]>(getListCalendarBillingEventsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCalendarBillingEventsQueryKey = (params?: ListCalendarBillingEventsParams,) => {
    return [
    `/api/calendar/billing-events`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCalendarBillingEventsQueryOptions = <TData = Awaited<ReturnType<typeof listCalendarBillingEvents>>, TError = ErrorType<unknown>>(params: ListCalendarBillingEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarBillingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCalendarBillingEventsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCalendarBillingEvents>>> = ({ signal }) => listCalendarBillingEvents(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCalendarBillingEvents>>, TError, TData> & { queryKey: QueryKey }
}

export type ListCalendarBillingEventsQueryResult = NonNullable<Awaited<ReturnType<typeof listCalendarBillingEvents>>>
export type ListCalendarBillingEventsQueryError = ErrorType<unknown>


/**
 * @summary List billing events (quote expirations, invoice due/paid/recurring dates) within a date range
 */

export function useListCalendarBillingEvents<TData = Awaited<ReturnType<typeof listCalendarBillingEvents>>, TError = ErrorType<unknown>>(
 params: ListCalendarBillingEventsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listCalendarBillingEvents>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListCalendarBillingEventsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Get company settings
 */
export const getSettings = async ( options?: RequestInit): Promise<CompanySettings> => {

  return customFetch<CompanySettings>(getGetSettingsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSettingsQueryKey = () => {
    return [
    `/api/settings`
    ] as const;
    }


export const getGetSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettings>>> = ({ signal }) => getSettings({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getSettings>>>
export type GetSettingsQueryError = ErrorType<unknown>


/**
 * @summary Get company settings
 */

export function useGetSettings<TData = Awaited<ReturnType<typeof getSettings>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSettings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetSettingsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateSettingsUrl = () => {




  return `/api/settings`
}

/**
 * @summary Update company settings
 */
export const updateSettings = async (updateSettingsBody: UpdateSettingsBody, options?: RequestInit): Promise<CompanySettings> => {

  return customFetch<CompanySettings>(getUpdateSettingsUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateSettingsBody)
  }
);}




export const getUpdateSettingsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<UpdateSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<UpdateSettingsBody>}, TContext> => {

const mutationKey = ['updateSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateSettings>>, {data: BodyType<UpdateSettingsBody>}> = (props) => {
          const {data} = props ?? {};

          return  updateSettings(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof updateSettings>>>
    export type UpdateSettingsMutationBody = BodyType<UpdateSettingsBody>
    export type UpdateSettingsMutationError = ErrorType<unknown>

    /**
 * @summary Update company settings
 */
export const useUpdateSettings = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateSettings>>, TError,{data: BodyType<UpdateSettingsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateSettings>>,
        TError,
        {data: BodyType<UpdateSettingsBody>},
        TContext
      > => {
      return useMutation(getUpdateSettingsMutationOptions(options));
    }

export const getSaveServiceAgreementUrl = () => {




  return `/api/settings/service-agreement`
}

/**
 * @summary Finalize and persist a newly uploaded service agreement PDF
 */
export const saveServiceAgreement = async (saveServiceAgreementBody: SaveServiceAgreementBody, options?: RequestInit): Promise<CompanySettings> => {

  return customFetch<CompanySettings>(getSaveServiceAgreementUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(saveServiceAgreementBody)
  }
);}




export const getSaveServiceAgreementMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceAgreement>>, TError,{data: BodyType<SaveServiceAgreementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveServiceAgreement>>, TError,{data: BodyType<SaveServiceAgreementBody>}, TContext> => {

const mutationKey = ['saveServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveServiceAgreement>>, {data: BodyType<SaveServiceAgreementBody>}> = (props) => {
          const {data} = props ?? {};

          return  saveServiceAgreement(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof saveServiceAgreement>>>
    export type SaveServiceAgreementMutationBody = BodyType<SaveServiceAgreementBody>
    export type SaveServiceAgreementMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Finalize and persist a newly uploaded service agreement PDF
 */
export const useSaveServiceAgreement = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveServiceAgreement>>, TError,{data: BodyType<SaveServiceAgreementBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveServiceAgreement>>,
        TError,
        {data: BodyType<SaveServiceAgreementBody>},
        TContext
      > => {
      return useMutation(getSaveServiceAgreementMutationOptions(options));
    }

export const getDeleteServiceAgreementUrl = () => {




  return `/api/settings/service-agreement`
}

/**
 * @summary Remove the current service agreement PDF
 */
export const deleteServiceAgreement = async ( options?: RequestInit): Promise<CompanySettings> => {

  return customFetch<CompanySettings>(getDeleteServiceAgreementUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteServiceAgreementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAgreement>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAgreement>>, TError,void, TContext> => {

const mutationKey = ['deleteServiceAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceAgreement>>, void> = () => {


          return  deleteServiceAgreement(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceAgreement>>>

    export type DeleteServiceAgreementMutationError = ErrorType<unknown>

    /**
 * @summary Remove the current service agreement PDF
 */
export const useDeleteServiceAgreement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAgreement>>, TError,void, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceAgreement>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDeleteServiceAgreementMutationOptions(options));
    }

export const getListTodosUrl = () => {




  return `/api/todos`
}

/**
 * @summary List all todos
 */
export const listTodos = async ( options?: RequestInit): Promise<TodoItem[]> => {

  return customFetch<TodoItem[]>(getListTodosUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListTodosQueryKey = () => {
    return [
    `/api/todos`
    ] as const;
    }


export const getListTodosQueryOptions = <TData = Awaited<ReturnType<typeof listTodos>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTodos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListTodosQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listTodos>>> = ({ signal }) => listTodos({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listTodos>>, TError, TData> & { queryKey: QueryKey }
}

export type ListTodosQueryResult = NonNullable<Awaited<ReturnType<typeof listTodos>>>
export type ListTodosQueryError = ErrorType<unknown>


/**
 * @summary List all todos
 */

export function useListTodos<TData = Awaited<ReturnType<typeof listTodos>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listTodos>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListTodosQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateTodoUrl = () => {




  return `/api/todos`
}

/**
 * @summary Create a todo
 */
export const createTodo = async (createTodoBody: CreateTodoBody, options?: RequestInit): Promise<TodoItem> => {

  return customFetch<TodoItem>(getCreateTodoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTodoBody)
  }
);}




export const getCreateTodoMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTodo>>, TError,{data: BodyType<CreateTodoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createTodo>>, TError,{data: BodyType<CreateTodoBody>}, TContext> => {

const mutationKey = ['createTodo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTodo>>, {data: BodyType<CreateTodoBody>}> = (props) => {
          const {data} = props ?? {};

          return  createTodo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateTodoMutationResult = NonNullable<Awaited<ReturnType<typeof createTodo>>>
    export type CreateTodoMutationBody = BodyType<CreateTodoBody>
    export type CreateTodoMutationError = ErrorType<unknown>

    /**
 * @summary Create a todo
 */
export const useCreateTodo = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTodo>>, TError,{data: BodyType<CreateTodoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createTodo>>,
        TError,
        {data: BodyType<CreateTodoBody>},
        TContext
      > => {
      return useMutation(getCreateTodoMutationOptions(options));
    }

export const getPatchTodoUrl = (id: number,) => {




  return `/api/todos/${id}`
}

/**
 * @summary Update a todo
 */
export const patchTodo = async (id: number,
    patchTodoBody: PatchTodoBody, options?: RequestInit): Promise<TodoItem> => {

  return customFetch<TodoItem>(getPatchTodoUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchTodoBody)
  }
);}




export const getPatchTodoMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTodo>>, TError,{id: number;data: BodyType<PatchTodoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTodo>>, TError,{id: number;data: BodyType<PatchTodoBody>}, TContext> => {

const mutationKey = ['patchTodo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTodo>>, {id: number;data: BodyType<PatchTodoBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchTodo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchTodoMutationResult = NonNullable<Awaited<ReturnType<typeof patchTodo>>>
    export type PatchTodoMutationBody = BodyType<PatchTodoBody>
    export type PatchTodoMutationError = ErrorType<void>

    /**
 * @summary Update a todo
 */
export const usePatchTodo = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTodo>>, TError,{id: number;data: BodyType<PatchTodoBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof patchTodo>>,
        TError,
        {id: number;data: BodyType<PatchTodoBody>},
        TContext
      > => {
      return useMutation(getPatchTodoMutationOptions(options));
    }

export const getDeleteTodoUrl = (id: number,) => {




  return `/api/todos/${id}`
}

/**
 * @summary Delete a todo
 */
export const deleteTodo = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteTodoUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteTodoMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTodo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTodo>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteTodo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTodo>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteTodo(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteTodoMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTodo>>>

    export type DeleteTodoMutationError = ErrorType<void>

    /**
 * @summary Delete a todo
 */
export const useDeleteTodo = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTodo>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteTodo>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteTodoMutationOptions(options));
    }

export const getImportFreeBuilderDraftUrl = () => {




  return `/api/import/free-builder`
}

/**
 * Creates a quote or invoice (plus its customer, line items and internal cost rows) from the draft the public free generator hands to the signup page. Used once, right after the visitor's first sign-in.
 *
 * @summary Import a draft from the free quote / invoice generator on quotrak.com
 */
export const importFreeBuilderDraft = async (importFreeBuilderBody: ImportFreeBuilderBody, options?: RequestInit): Promise<ImportFreeBuilderResult> => {

  return customFetch<ImportFreeBuilderResult>(getImportFreeBuilderDraftUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importFreeBuilderBody)
  }
);}




export const getImportFreeBuilderDraftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFreeBuilderDraft>>, TError,{data: BodyType<ImportFreeBuilderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importFreeBuilderDraft>>, TError,{data: BodyType<ImportFreeBuilderBody>}, TContext> => {

const mutationKey = ['importFreeBuilderDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importFreeBuilderDraft>>, {data: BodyType<ImportFreeBuilderBody>}> = (props) => {
          const {data} = props ?? {};

          return  importFreeBuilderDraft(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportFreeBuilderDraftMutationResult = NonNullable<Awaited<ReturnType<typeof importFreeBuilderDraft>>>
    export type ImportFreeBuilderDraftMutationBody = BodyType<ImportFreeBuilderBody>
    export type ImportFreeBuilderDraftMutationError = ErrorType<unknown>

    /**
 * @summary Import a draft from the free quote / invoice generator on quotrak.com
 */
export const useImportFreeBuilderDraft = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importFreeBuilderDraft>>, TError,{data: BodyType<ImportFreeBuilderBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importFreeBuilderDraft>>,
        TError,
        {data: BodyType<ImportFreeBuilderBody>},
        TContext
      > => {
      return useMutation(getImportFreeBuilderDraftMutationOptions(options));
    }

export const getImportCustomersUrl = () => {




  return `/api/customers/import`
}

/**
 * @summary Bulk import customers from rows
 */
export const importCustomers = async (importRowsBody: ImportRowsBody, options?: RequestInit): Promise<ImportResult> => {

  return customFetch<ImportResult>(getImportCustomersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importRowsBody)
  }
);}




export const getImportCustomersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importCustomers>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importCustomers>>, TError,{data: BodyType<ImportRowsBody>}, TContext> => {

const mutationKey = ['importCustomers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importCustomers>>, {data: BodyType<ImportRowsBody>}> = (props) => {
          const {data} = props ?? {};

          return  importCustomers(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof importCustomers>>>
    export type ImportCustomersMutationBody = BodyType<ImportRowsBody>
    export type ImportCustomersMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import customers from rows
 */
export const useImportCustomers = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importCustomers>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importCustomers>>,
        TError,
        {data: BodyType<ImportRowsBody>},
        TContext
      > => {
      return useMutation(getImportCustomersMutationOptions(options));
    }

export const getImportProductsUrl = () => {




  return `/api/products/import`
}

/**
 * @summary Bulk import products from rows
 */
export const importProducts = async (importRowsBody: ImportRowsBody, options?: RequestInit): Promise<ImportResult> => {

  return customFetch<ImportResult>(getImportProductsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importRowsBody)
  }
);}




export const getImportProductsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<ImportRowsBody>}, TContext> => {

const mutationKey = ['importProducts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importProducts>>, {data: BodyType<ImportRowsBody>}> = (props) => {
          const {data} = props ?? {};

          return  importProducts(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportProductsMutationResult = NonNullable<Awaited<ReturnType<typeof importProducts>>>
    export type ImportProductsMutationBody = BodyType<ImportRowsBody>
    export type ImportProductsMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import products from rows
 */
export const useImportProducts = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importProducts>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importProducts>>,
        TError,
        {data: BodyType<ImportRowsBody>},
        TContext
      > => {
      return useMutation(getImportProductsMutationOptions(options));
    }

export const getImportInternalCatalogUrl = () => {




  return `/api/internal-catalog/import`
}

/**
 * @summary Bulk import internal catalog items from rows
 */
export const importInternalCatalog = async (importRowsBody: ImportRowsBody, options?: RequestInit): Promise<ImportResult> => {

  return customFetch<ImportResult>(getImportInternalCatalogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(importRowsBody)
  }
);}




export const getImportInternalCatalogMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInternalCatalog>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof importInternalCatalog>>, TError,{data: BodyType<ImportRowsBody>}, TContext> => {

const mutationKey = ['importInternalCatalog'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof importInternalCatalog>>, {data: BodyType<ImportRowsBody>}> = (props) => {
          const {data} = props ?? {};

          return  importInternalCatalog(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ImportInternalCatalogMutationResult = NonNullable<Awaited<ReturnType<typeof importInternalCatalog>>>
    export type ImportInternalCatalogMutationBody = BodyType<ImportRowsBody>
    export type ImportInternalCatalogMutationError = ErrorType<unknown>

    /**
 * @summary Bulk import internal catalog items from rows
 */
export const useImportInternalCatalog = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof importInternalCatalog>>, TError,{data: BodyType<ImportRowsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof importInternalCatalog>>,
        TError,
        {data: BodyType<ImportRowsBody>},
        TContext
      > => {
      return useMutation(getImportInternalCatalogMutationOptions(options));
    }

export const getGetEstimatesByStatusUrl = (params?: GetEstimatesByStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/estimates-by-status?${stringifiedParams}` : `/api/dashboard/estimates-by-status`
}

/**
 * @summary Get estimate counts grouped by status
 */
export const getEstimatesByStatus = async (params?: GetEstimatesByStatusParams, options?: RequestInit): Promise<StatusCount[]> => {

  return customFetch<StatusCount[]>(getGetEstimatesByStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetEstimatesByStatusQueryKey = (params?: GetEstimatesByStatusParams,) => {
    return [
    `/api/dashboard/estimates-by-status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetEstimatesByStatusQueryOptions = <TData = Awaited<ReturnType<typeof getEstimatesByStatus>>, TError = ErrorType<unknown>>(params?: GetEstimatesByStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEstimatesByStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEstimatesByStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEstimatesByStatus>>> = ({ signal }) => getEstimatesByStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEstimatesByStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetEstimatesByStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getEstimatesByStatus>>>
export type GetEstimatesByStatusQueryError = ErrorType<unknown>


/**
 * @summary Get estimate counts grouped by status
 */

export function useGetEstimatesByStatus<TData = Awaited<ReturnType<typeof getEstimatesByStatus>>, TError = ErrorType<unknown>>(
 params?: GetEstimatesByStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getEstimatesByStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetEstimatesByStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetProfitPerEstimateUrl = (params?: GetProfitPerEstimateParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dashboard/profit-per-estimate?${stringifiedParams}` : `/api/dashboard/profit-per-estimate`
}

/**
 * @summary Get profit for each estimate ordered by date
 */
export const getProfitPerEstimate = async (params?: GetProfitPerEstimateParams, options?: RequestInit): Promise<ProfitPerEstimate[]> => {

  return customFetch<ProfitPerEstimate[]>(getGetProfitPerEstimateUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProfitPerEstimateQueryKey = (params?: GetProfitPerEstimateParams,) => {
    return [
    `/api/dashboard/profit-per-estimate`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProfitPerEstimateQueryOptions = <TData = Awaited<ReturnType<typeof getProfitPerEstimate>>, TError = ErrorType<unknown>>(params?: GetProfitPerEstimateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitPerEstimate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProfitPerEstimateQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProfitPerEstimate>>> = ({ signal }) => getProfitPerEstimate(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProfitPerEstimate>>, TError, TData> & { queryKey: QueryKey }
}

export type GetProfitPerEstimateQueryResult = NonNullable<Awaited<ReturnType<typeof getProfitPerEstimate>>>
export type GetProfitPerEstimateQueryError = ErrorType<unknown>


/**
 * @summary Get profit for each estimate ordered by date
 */

export function useGetProfitPerEstimate<TData = Awaited<ReturnType<typeof getProfitPerEstimate>>, TError = ErrorType<unknown>>(
 params?: GetProfitPerEstimateParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getProfitPerEstimate>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetProfitPerEstimateQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRequestUploadUrlUrl = () => {




  return `/api/storage/uploads/request-url`
}

/**
 * @summary Request a presigned URL for file upload
 */
export const requestUploadUrl = async (uploadUrlRequest: UploadUrlRequest, options?: RequestInit): Promise<UploadUrlResponse> => {

  return customFetch<UploadUrlResponse>(getRequestUploadUrlUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(uploadUrlRequest)
  }
);}




export const getRequestUploadUrlMutationOptions = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext> => {

const mutationKey = ['requestUploadUrl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestUploadUrl>>, {data: BodyType<UploadUrlRequest>}> = (props) => {
          const {data} = props ?? {};

          return  requestUploadUrl(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestUploadUrlMutationResult = NonNullable<Awaited<ReturnType<typeof requestUploadUrl>>>
    export type RequestUploadUrlMutationBody = BodyType<UploadUrlRequest>
    export type RequestUploadUrlMutationError = ErrorType<ErrorEnvelope>

    /**
 * @summary Request a presigned URL for file upload
 */
export const useRequestUploadUrl = <TError = ErrorType<ErrorEnvelope>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestUploadUrl>>, TError,{data: BodyType<UploadUrlRequest>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestUploadUrl>>,
        TError,
        {data: BodyType<UploadUrlRequest>},
        TContext
      > => {
      return useMutation(getRequestUploadUrlMutationOptions(options));
    }

export const getGetPublicObjectUrl = (filePath: string,) => {




  return `/api/storage/public-objects/${filePath}`
}

/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const getPublicObject = async (filePath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetPublicObjectUrl(filePath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicObjectQueryKey = (filePath: string,) => {
    return [
    `/api/storage/public-objects/${filePath}`
    ] as const;
    }


export const getGetPublicObjectQueryOptions = <TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicObjectQueryKey(filePath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicObject>>> = ({ signal }) => getPublicObject(filePath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: filePath !== null && filePath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicObject>>>
export type GetPublicObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */

export function useGetPublicObject<TData = Awaited<ReturnType<typeof getPublicObject>>, TError = ErrorType<ErrorEnvelope>>(
 filePath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicObjectQueryOptions(filePath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetStorageObjectUrl = (objectPath: string,) => {




  return `/api/storage/objects/${objectPath}`
}

/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const getStorageObject = async (objectPath: string, options?: RequestInit): Promise<Blob> => {

  return customFetch<Blob>(getGetStorageObjectUrl(objectPath),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetStorageObjectQueryKey = (objectPath: string,) => {
    return [
    `/api/storage/objects/${objectPath}`
    ] as const;
    }


export const getGetStorageObjectQueryOptions = <TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetStorageObjectQueryKey(objectPath);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getStorageObject>>> = ({ signal }) => getStorageObject(objectPath, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: objectPath !== null && objectPath !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData> & { queryKey: QueryKey }
}

export type GetStorageObjectQueryResult = NonNullable<Awaited<ReturnType<typeof getStorageObject>>>
export type GetStorageObjectQueryError = ErrorType<ErrorEnvelope>


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */

export function useGetStorageObject<TData = Awaited<ReturnType<typeof getStorageObject>>, TError = ErrorType<ErrorEnvelope>>(
 objectPath: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getStorageObject>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetStorageObjectQueryOptions(objectPath,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListAttachmentsUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/attachments`
}

/**
 * @summary List attachments for an estimate
 */
export const listAttachments = async (estimateId: number, options?: RequestInit): Promise<Attachment[]> => {

  return customFetch<Attachment[]>(getListAttachmentsUrl(estimateId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListAttachmentsQueryKey = (estimateId: number,) => {
    return [
    `/api/estimates/${estimateId}/attachments`
    ] as const;
    }


export const getListAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listAttachments>>, TError = ErrorType<unknown>>(estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAttachmentsQueryKey(estimateId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAttachments>>> = ({ signal }) => listAttachments(estimateId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: estimateId !== null && estimateId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listAttachments>>>
export type ListAttachmentsQueryError = ErrorType<unknown>


/**
 * @summary List attachments for an estimate
 */

export function useListAttachments<TData = Awaited<ReturnType<typeof listAttachments>>, TError = ErrorType<unknown>>(
 estimateId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListAttachmentsQueryOptions(estimateId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateAttachmentUrl = (estimateId: number,) => {




  return `/api/estimates/${estimateId}/attachments`
}

/**
 * @summary Save attachment metadata after upload
 */
export const createAttachment = async (estimateId: number,
    createAttachmentBody: CreateAttachmentBody, options?: RequestInit): Promise<Attachment> => {

  return customFetch<Attachment>(getCreateAttachmentUrl(estimateId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAttachmentBody)
  }
);}




export const getCreateAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachment>>, TError,{estimateId: number;data: BodyType<CreateAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAttachment>>, TError,{estimateId: number;data: BodyType<CreateAttachmentBody>}, TContext> => {

const mutationKey = ['createAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAttachment>>, {estimateId: number;data: BodyType<CreateAttachmentBody>}> = (props) => {
          const {estimateId,data} = props ?? {};

          return  createAttachment(estimateId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createAttachment>>>
    export type CreateAttachmentMutationBody = BodyType<CreateAttachmentBody>
    export type CreateAttachmentMutationError = ErrorType<unknown>

    /**
 * @summary Save attachment metadata after upload
 */
export const useCreateAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAttachment>>, TError,{estimateId: number;data: BodyType<CreateAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAttachment>>,
        TError,
        {estimateId: number;data: BodyType<CreateAttachmentBody>},
        TContext
      > => {
      return useMutation(getCreateAttachmentMutationOptions(options));
    }

export const getDeleteAttachmentUrl = (estimateId: number,
    attachmentId: number,) => {




  return `/api/estimates/${estimateId}/attachments/${attachmentId}`
}

/**
 * @summary Delete an attachment (metadata + object from storage)
 */
export const deleteAttachment = async (estimateId: number,
    attachmentId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteAttachmentUrl(estimateId,attachmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{estimateId: number;attachmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{estimateId: number;attachmentId: number}, TContext> => {

const mutationKey = ['deleteAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAttachment>>, {estimateId: number;attachmentId: number}> = (props) => {
          const {estimateId,attachmentId} = props ?? {};

          return  deleteAttachment(estimateId,attachmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAttachment>>>

    export type DeleteAttachmentMutationError = ErrorType<unknown>

    /**
 * @summary Delete an attachment (metadata + object from storage)
 */
export const useDeleteAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAttachment>>, TError,{estimateId: number;attachmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteAttachment>>,
        TError,
        {estimateId: number;attachmentId: number},
        TContext
      > => {
      return useMutation(getDeleteAttachmentMutationOptions(options));
    }

export const getListInvoiceAttachmentsUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/attachments`
}

/**
 * @summary List attachments for an invoice
 */
export const listInvoiceAttachments = async (invoiceId: number, options?: RequestInit): Promise<InvoiceAttachment[]> => {

  return customFetch<InvoiceAttachment[]>(getListInvoiceAttachmentsUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoiceAttachmentsQueryKey = (invoiceId: number,) => {
    return [
    `/api/invoices/${invoiceId}/attachments`
    ] as const;
    }


export const getListInvoiceAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof listInvoiceAttachments>>, TError = ErrorType<unknown>>(invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoiceAttachmentsQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoiceAttachments>>> = ({ signal }) => listInvoiceAttachments(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoiceAttachments>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoiceAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoiceAttachments>>>
export type ListInvoiceAttachmentsQueryError = ErrorType<unknown>


/**
 * @summary List attachments for an invoice
 */

export function useListInvoiceAttachments<TData = Awaited<ReturnType<typeof listInvoiceAttachments>>, TError = ErrorType<unknown>>(
 invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceAttachments>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoiceAttachmentsQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvoiceAttachmentUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/attachments`
}

/**
 * @summary Save invoice attachment metadata after upload
 */
export const createInvoiceAttachment = async (invoiceId: number,
    createAttachmentBody: CreateAttachmentBody, options?: RequestInit): Promise<InvoiceAttachment> => {

  return customFetch<InvoiceAttachment>(getCreateInvoiceAttachmentUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAttachmentBody)
  }
);}




export const getCreateInvoiceAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceAttachment>>, TError,{invoiceId: number;data: BodyType<CreateAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoiceAttachment>>, TError,{invoiceId: number;data: BodyType<CreateAttachmentBody>}, TContext> => {

const mutationKey = ['createInvoiceAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoiceAttachment>>, {invoiceId: number;data: BodyType<CreateAttachmentBody>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  createInvoiceAttachment(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoiceAttachment>>>
    export type CreateInvoiceAttachmentMutationBody = BodyType<CreateAttachmentBody>
    export type CreateInvoiceAttachmentMutationError = ErrorType<unknown>

    /**
 * @summary Save invoice attachment metadata after upload
 */
export const useCreateInvoiceAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceAttachment>>, TError,{invoiceId: number;data: BodyType<CreateAttachmentBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoiceAttachment>>,
        TError,
        {invoiceId: number;data: BodyType<CreateAttachmentBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceAttachmentMutationOptions(options));
    }

export const getDeleteInvoiceAttachmentUrl = (invoiceId: number,
    attachmentId: number,) => {




  return `/api/invoices/${invoiceId}/attachments/${attachmentId}`
}

/**
 * @summary Delete an invoice attachment (metadata + object from storage)
 */
export const deleteInvoiceAttachment = async (invoiceId: number,
    attachmentId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInvoiceAttachmentUrl(invoiceId,attachmentId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInvoiceAttachmentMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceAttachment>>, TError,{invoiceId: number;attachmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceAttachment>>, TError,{invoiceId: number;attachmentId: number}, TContext> => {

const mutationKey = ['deleteInvoiceAttachment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoiceAttachment>>, {invoiceId: number;attachmentId: number}> = (props) => {
          const {invoiceId,attachmentId} = props ?? {};

          return  deleteInvoiceAttachment(invoiceId,attachmentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceAttachmentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoiceAttachment>>>

    export type DeleteInvoiceAttachmentMutationError = ErrorType<unknown>

    /**
 * @summary Delete an invoice attachment (metadata + object from storage)
 */
export const useDeleteInvoiceAttachment = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceAttachment>>, TError,{invoiceId: number;attachmentId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoiceAttachment>>,
        TError,
        {invoiceId: number;attachmentId: number},
        TContext
      > => {
      return useMutation(getDeleteInvoiceAttachmentMutationOptions(options));
    }

export const getConvertEstimateToInvoiceUrl = (id: number,) => {




  return `/api/estimates/${id}/convert-to-invoice`
}

/**
 * @summary Convert an accepted estimate to an invoice
 */
export const convertEstimateToInvoice = async (id: number, options?: RequestInit): Promise<Invoice> => {

  return customFetch<Invoice>(getConvertEstimateToInvoiceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getConvertEstimateToInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertEstimateToInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof convertEstimateToInvoice>>, TError,{id: number}, TContext> => {

const mutationKey = ['convertEstimateToInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof convertEstimateToInvoice>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  convertEstimateToInvoice(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ConvertEstimateToInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof convertEstimateToInvoice>>>

    export type ConvertEstimateToInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Convert an accepted estimate to an invoice
 */
export const useConvertEstimateToInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof convertEstimateToInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof convertEstimateToInvoice>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getConvertEstimateToInvoiceMutationOptions(options));
    }

export const getDuplicateEstimateUrl = (id: number,) => {




  return `/api/estimates/${id}/duplicate`
}

/**
 * @summary Duplicate an estimate
 */
export const duplicateEstimate = async (id: number, options?: RequestInit): Promise<DuplicateEstimate201> => {

  return customFetch<DuplicateEstimate201>(getDuplicateEstimateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDuplicateEstimateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEstimate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateEstimate>>, TError,{id: number}, TContext> => {

const mutationKey = ['duplicateEstimate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateEstimate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  duplicateEstimate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateEstimateMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateEstimate>>>

    export type DuplicateEstimateMutationError = ErrorType<unknown>

    /**
 * @summary Duplicate an estimate
 */
export const useDuplicateEstimate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateEstimate>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateEstimate>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDuplicateEstimateMutationOptions(options));
    }

export const getListInvoicesUrl = (params?: ListInvoicesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices?${stringifiedParams}` : `/api/invoices`
}

/**
 * @summary List all invoices
 */
export const listInvoices = async (params?: ListInvoicesParams, options?: RequestInit): Promise<Invoice[]> => {

  return customFetch<Invoice[]>(getListInvoicesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoicesQueryKey = (params?: ListInvoicesParams,) => {
    return [
    `/api/invoices`, ...(params ? [params] : [])
    ] as const;
    }


export const getListInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof listInvoices>>, TError = ErrorType<unknown>>(params?: ListInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoicesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoices>>> = ({ signal }) => listInvoices(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoices>>>
export type ListInvoicesQueryError = ErrorType<unknown>


/**
 * @summary List all invoices
 */

export function useListInvoices<TData = Awaited<ReturnType<typeof listInvoices>>, TError = ErrorType<unknown>>(
 params?: ListInvoicesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoices>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvoiceUrl = () => {




  return `/api/invoices`
}

/**
 * @summary Create an invoice
 */
export const createInvoice = async (createInvoiceBody: CreateInvoiceBody, options?: RequestInit): Promise<InvoiceDetail> => {

  return customFetch<InvoiceDetail>(getCreateInvoiceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createInvoiceBody)
  }
);}




export const getCreateInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext> => {

const mutationKey = ['createInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoice>>, {data: BodyType<CreateInvoiceBody>}> = (props) => {
          const {data} = props ?? {};

          return  createInvoice(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoice>>>
    export type CreateInvoiceMutationBody = BodyType<CreateInvoiceBody>
    export type CreateInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Create an invoice
 */
export const useCreateInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoice>>, TError,{data: BodyType<CreateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoice>>,
        TError,
        {data: BodyType<CreateInvoiceBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceMutationOptions(options));
    }

export const getGetInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}`
}

/**
 * @summary Get invoice with all details
 */
export const getInvoice = async (id: number, options?: RequestInit): Promise<InvoiceDetail> => {

  return customFetch<InvoiceDetail>(getGetInvoiceUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoiceQueryKey = (id: number,) => {
    return [
    `/api/invoices/${id}`
    ] as const;
    }


export const getGetInvoiceQueryOptions = <TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<unknown>>(id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoice>>> = ({ signal }) => getInvoice(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoice>>>
export type GetInvoiceQueryError = ErrorType<unknown>


/**
 * @summary Get invoice with all details
 */

export function useGetInvoice<TData = Awaited<ReturnType<typeof getInvoice>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoice>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInvoiceQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}`
}

/**
 * @summary Update an invoice
 */
export const updateInvoice = async (id: number,
    updateInvoiceBody: UpdateInvoiceBody, options?: RequestInit): Promise<Invoice> => {

  return customFetch<Invoice>(getUpdateInvoiceUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateInvoiceBody)
  }
);}




export const getUpdateInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext> => {

const mutationKey = ['updateInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoice>>, {id: number;data: BodyType<UpdateInvoiceBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateInvoice(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoice>>>
    export type UpdateInvoiceMutationBody = BodyType<UpdateInvoiceBody>
    export type UpdateInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Update an invoice
 */
export const useUpdateInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoice>>, TError,{id: number;data: BodyType<UpdateInvoiceBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoice>>,
        TError,
        {id: number;data: BodyType<UpdateInvoiceBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceMutationOptions(options));
    }

export const getDeleteInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}`
}

/**
 * @summary Delete an invoice
 */
export const deleteInvoice = async (id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInvoiceUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoice>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteInvoice(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoice>>>

    export type DeleteInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Delete an invoice
 */
export const useDeleteInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoice>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteInvoiceMutationOptions(options));
    }

export const getMarkDepositReceivedUrl = (id: number,) => {




  return `/api/invoices/${id}/mark-deposit-received`
}

/**
 * @summary Mark deposit as received (creates child invoice + payment in one step)
 */
export const markDepositReceived = async (id: number,
    markDepositReceivedBody: MarkDepositReceivedBody, options?: RequestInit): Promise<InvoiceDetail> => {

  return customFetch<InvoiceDetail>(getMarkDepositReceivedUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(markDepositReceivedBody)
  }
);}




export const getMarkDepositReceivedMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDepositReceived>>, TError,{id: number;data: BodyType<MarkDepositReceivedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markDepositReceived>>, TError,{id: number;data: BodyType<MarkDepositReceivedBody>}, TContext> => {

const mutationKey = ['markDepositReceived'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markDepositReceived>>, {id: number;data: BodyType<MarkDepositReceivedBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  markDepositReceived(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MarkDepositReceivedMutationResult = NonNullable<Awaited<ReturnType<typeof markDepositReceived>>>
    export type MarkDepositReceivedMutationBody = BodyType<MarkDepositReceivedBody>
    export type MarkDepositReceivedMutationError = ErrorType<void>

    /**
 * @summary Mark deposit as received (creates child invoice + payment in one step)
 */
export const useMarkDepositReceived = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markDepositReceived>>, TError,{id: number;data: BodyType<MarkDepositReceivedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof markDepositReceived>>,
        TError,
        {id: number;data: BodyType<MarkDepositReceivedBody>},
        TContext
      > => {
      return useMutation(getMarkDepositReceivedMutationOptions(options));
    }

export const getDuplicateInvoiceUrl = (id: number,) => {




  return `/api/invoices/${id}/duplicate`
}

/**
 * @summary Duplicate an invoice
 */
export const duplicateInvoice = async (id: number, options?: RequestInit): Promise<DuplicateInvoice201> => {

  return customFetch<DuplicateInvoice201>(getDuplicateInvoiceUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}




export const getDuplicateInvoiceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof duplicateInvoice>>, TError,{id: number}, TContext> => {

const mutationKey = ['duplicateInvoice'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateInvoice>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  duplicateInvoice(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateInvoiceMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateInvoice>>>

    export type DuplicateInvoiceMutationError = ErrorType<unknown>

    /**
 * @summary Duplicate an invoice
 */
export const useDuplicateInvoice = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateInvoice>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof duplicateInvoice>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDuplicateInvoiceMutationOptions(options));
    }

export const getListInvoiceLineItemsUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/line-items`
}

/**
 * @summary List line items for an invoice
 */
export const listInvoiceLineItems = async (invoiceId: number, options?: RequestInit): Promise<InvoiceLineItem[]> => {

  return customFetch<InvoiceLineItem[]>(getListInvoiceLineItemsUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoiceLineItemsQueryKey = (invoiceId: number,) => {
    return [
    `/api/invoices/${invoiceId}/line-items`
    ] as const;
    }


export const getListInvoiceLineItemsQueryOptions = <TData = Awaited<ReturnType<typeof listInvoiceLineItems>>, TError = ErrorType<unknown>>(invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoiceLineItemsQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoiceLineItems>>> = ({ signal }) => listInvoiceLineItems(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItems>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoiceLineItemsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoiceLineItems>>>
export type ListInvoiceLineItemsQueryError = ErrorType<unknown>


/**
 * @summary List line items for an invoice
 */

export function useListInvoiceLineItems<TData = Awaited<ReturnType<typeof listInvoiceLineItems>>, TError = ErrorType<unknown>>(
 invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItems>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoiceLineItemsQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvoiceLineItemUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/line-items`
}

/**
 * @summary Add a line item to an invoice
 */
export const createInvoiceLineItem = async (invoiceId: number,
    createLineItemBody: CreateLineItemBody, options?: RequestInit): Promise<InvoiceLineItem> => {

  return customFetch<InvoiceLineItem>(getCreateInvoiceLineItemUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemBody)
  }
);}




export const getCreateInvoiceLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItem>>, TError,{invoiceId: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItem>>, TError,{invoiceId: number;data: BodyType<CreateLineItemBody>}, TContext> => {

const mutationKey = ['createInvoiceLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoiceLineItem>>, {invoiceId: number;data: BodyType<CreateLineItemBody>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  createInvoiceLineItem(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoiceLineItem>>>
    export type CreateInvoiceLineItemMutationBody = BodyType<CreateLineItemBody>
    export type CreateInvoiceLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Add a line item to an invoice
 */
export const useCreateInvoiceLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItem>>, TError,{invoiceId: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoiceLineItem>>,
        TError,
        {invoiceId: number;data: BodyType<CreateLineItemBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceLineItemMutationOptions(options));
    }

export const getUpdateInvoiceLineItemUrl = (invoiceId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${id}`
}

/**
 * @summary Update an invoice line item
 */
export const updateInvoiceLineItem = async (invoiceId: number,
    id: number,
    createLineItemBody: CreateLineItemBody, options?: RequestInit): Promise<InvoiceLineItem> => {

  return customFetch<InvoiceLineItem>(getUpdateInvoiceLineItemUrl(invoiceId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemBody)
  }
);}




export const getUpdateInvoiceLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItem>>, TError,{invoiceId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItem>>, TError,{invoiceId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext> => {

const mutationKey = ['updateInvoiceLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoiceLineItem>>, {invoiceId: number;id: number;data: BodyType<CreateLineItemBody>}> = (props) => {
          const {invoiceId,id,data} = props ?? {};

          return  updateInvoiceLineItem(invoiceId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoiceLineItem>>>
    export type UpdateInvoiceLineItemMutationBody = BodyType<CreateLineItemBody>
    export type UpdateInvoiceLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Update an invoice line item
 */
export const useUpdateInvoiceLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItem>>, TError,{invoiceId: number;id: number;data: BodyType<CreateLineItemBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoiceLineItem>>,
        TError,
        {invoiceId: number;id: number;data: BodyType<CreateLineItemBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceLineItemMutationOptions(options));
    }

export const getDeleteInvoiceLineItemUrl = (invoiceId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${id}`
}

/**
 * @summary Delete an invoice line item
 */
export const deleteInvoiceLineItem = async (invoiceId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInvoiceLineItemUrl(invoiceId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInvoiceLineItemMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItem>>, TError,{invoiceId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItem>>, TError,{invoiceId: number;id: number}, TContext> => {

const mutationKey = ['deleteInvoiceLineItem'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoiceLineItem>>, {invoiceId: number;id: number}> = (props) => {
          const {invoiceId,id} = props ?? {};

          return  deleteInvoiceLineItem(invoiceId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceLineItemMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoiceLineItem>>>

    export type DeleteInvoiceLineItemMutationError = ErrorType<unknown>

    /**
 * @summary Delete an invoice line item
 */
export const useDeleteInvoiceLineItem = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItem>>, TError,{invoiceId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoiceLineItem>>,
        TError,
        {invoiceId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteInvoiceLineItemMutationOptions(options));
    }

export const getUpdateInvoiceLineItemNoteUrl = (invoiceId: number,
    lineItemId: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${lineItemId}/note`
}

/**
 * @summary Set or clear private note on an invoice line item
 */
export const updateInvoiceLineItemNote = async (invoiceId: number,
    lineItemId: number,
    updateLineItemNoteBody: UpdateLineItemNoteBody, options?: RequestInit): Promise<InvoiceLineItem> => {

  return customFetch<InvoiceLineItem>(getUpdateInvoiceLineItemNoteUrl(invoiceId,lineItemId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLineItemNoteBody)
  }
);}




export const getUpdateInvoiceLineItemNoteMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemNote>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemNote>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext> => {

const mutationKey = ['updateInvoiceLineItemNote'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoiceLineItemNote>>, {invoiceId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}> = (props) => {
          const {invoiceId,lineItemId,data} = props ?? {};

          return  updateInvoiceLineItemNote(invoiceId,lineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceLineItemNoteMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoiceLineItemNote>>>
    export type UpdateInvoiceLineItemNoteMutationBody = BodyType<UpdateLineItemNoteBody>
    export type UpdateInvoiceLineItemNoteMutationError = ErrorType<unknown>

    /**
 * @summary Set or clear private note on an invoice line item
 */
export const useUpdateInvoiceLineItemNote = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemNote>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoiceLineItemNote>>,
        TError,
        {invoiceId: number;lineItemId: number;data: BodyType<UpdateLineItemNoteBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceLineItemNoteMutationOptions(options));
    }

export const getListInvoiceLineItemGroupsUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/groups`
}

/**
 * @summary List line item groups for an invoice
 */
export const listInvoiceLineItemGroups = async (invoiceId: number, options?: RequestInit): Promise<InvoiceLineItemGroup[]> => {

  return customFetch<InvoiceLineItemGroup[]>(getListInvoiceLineItemGroupsUrl(invoiceId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoiceLineItemGroupsQueryKey = (invoiceId: number,) => {
    return [
    `/api/invoices/${invoiceId}/groups`
    ] as const;
    }


export const getListInvoiceLineItemGroupsQueryOptions = <TData = Awaited<ReturnType<typeof listInvoiceLineItemGroups>>, TError = ErrorType<unknown>>(invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItemGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoiceLineItemGroupsQueryKey(invoiceId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoiceLineItemGroups>>> = ({ signal }) => listInvoiceLineItemGroups(invoiceId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItemGroups>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoiceLineItemGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoiceLineItemGroups>>>
export type ListInvoiceLineItemGroupsQueryError = ErrorType<unknown>


/**
 * @summary List line item groups for an invoice
 */

export function useListInvoiceLineItemGroups<TData = Awaited<ReturnType<typeof listInvoiceLineItemGroups>>, TError = ErrorType<unknown>>(
 invoiceId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceLineItemGroups>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoiceLineItemGroupsQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvoiceLineItemGroupUrl = (invoiceId: number,) => {




  return `/api/invoices/${invoiceId}/groups`
}

/**
 * @summary Create a new invoice line item group
 */
export const createInvoiceLineItemGroup = async (invoiceId: number,
    createLineItemGroupBody: CreateLineItemGroupBody, options?: RequestInit): Promise<InvoiceLineItemGroup> => {

  return customFetch<InvoiceLineItemGroup>(getCreateInvoiceLineItemGroupUrl(invoiceId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createLineItemGroupBody)
  }
);}




export const getCreateInvoiceLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItemGroup>>, TError,{invoiceId: number;data: BodyType<CreateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItemGroup>>, TError,{invoiceId: number;data: BodyType<CreateLineItemGroupBody>}, TContext> => {

const mutationKey = ['createInvoiceLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoiceLineItemGroup>>, {invoiceId: number;data: BodyType<CreateLineItemGroupBody>}> = (props) => {
          const {invoiceId,data} = props ?? {};

          return  createInvoiceLineItemGroup(invoiceId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoiceLineItemGroup>>>
    export type CreateInvoiceLineItemGroupMutationBody = BodyType<CreateLineItemGroupBody>
    export type CreateInvoiceLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Create a new invoice line item group
 */
export const useCreateInvoiceLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceLineItemGroup>>, TError,{invoiceId: number;data: BodyType<CreateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoiceLineItemGroup>>,
        TError,
        {invoiceId: number;data: BodyType<CreateLineItemGroupBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceLineItemGroupMutationOptions(options));
    }

export const getUpdateInvoiceLineItemGroupUrl = (invoiceId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/groups/${id}`
}

/**
 * @summary Update an invoice line item group
 */
export const updateInvoiceLineItemGroup = async (invoiceId: number,
    id: number,
    updateLineItemGroupBody: UpdateLineItemGroupBody, options?: RequestInit): Promise<InvoiceLineItemGroup> => {

  return customFetch<InvoiceLineItemGroup>(getUpdateInvoiceLineItemGroupUrl(invoiceId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateLineItemGroupBody)
  }
);}




export const getUpdateInvoiceLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext> => {

const mutationKey = ['updateInvoiceLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>, {invoiceId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}> = (props) => {
          const {invoiceId,id,data} = props ?? {};

          return  updateInvoiceLineItemGroup(invoiceId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>>
    export type UpdateInvoiceLineItemGroupMutationBody = BodyType<UpdateLineItemGroupBody>
    export type UpdateInvoiceLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Update an invoice line item group
 */
export const useUpdateInvoiceLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number;data: BodyType<UpdateLineItemGroupBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoiceLineItemGroup>>,
        TError,
        {invoiceId: number;id: number;data: BodyType<UpdateLineItemGroupBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceLineItemGroupMutationOptions(options));
    }

export const getDeleteInvoiceLineItemGroupUrl = (invoiceId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/groups/${id}`
}

/**
 * @summary Delete an invoice line item group (ungrouping its items)
 */
export const deleteInvoiceLineItemGroup = async (invoiceId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInvoiceLineItemGroupUrl(invoiceId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInvoiceLineItemGroupMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number}, TContext> => {

const mutationKey = ['deleteInvoiceLineItemGroup'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>, {invoiceId: number;id: number}> = (props) => {
          const {invoiceId,id} = props ?? {};

          return  deleteInvoiceLineItemGroup(invoiceId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceLineItemGroupMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>>

    export type DeleteInvoiceLineItemGroupMutationError = ErrorType<unknown>

    /**
 * @summary Delete an invoice line item group (ungrouping its items)
 */
export const useDeleteInvoiceLineItemGroup = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>, TError,{invoiceId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoiceLineItemGroup>>,
        TError,
        {invoiceId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteInvoiceLineItemGroupMutationOptions(options));
    }

export const getListInvoiceCostsUrl = (invoiceId: number,
    lineItemId: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${lineItemId}/costs`
}

/**
 * @summary List internal costs for an invoice line item
 */
export const listInvoiceCosts = async (invoiceId: number,
    lineItemId: number, options?: RequestInit): Promise<Material[]> => {

  return customFetch<Material[]>(getListInvoiceCostsUrl(invoiceId,lineItemId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListInvoiceCostsQueryKey = (invoiceId: number,
    lineItemId: number,) => {
    return [
    `/api/invoices/${invoiceId}/line-items/${lineItemId}/costs`
    ] as const;
    }


export const getListInvoiceCostsQueryOptions = <TData = Awaited<ReturnType<typeof listInvoiceCosts>>, TError = ErrorType<unknown>>(invoiceId: number,
    lineItemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListInvoiceCostsQueryKey(invoiceId,lineItemId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listInvoiceCosts>>> = ({ signal }) => listInvoiceCosts(invoiceId,lineItemId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: invoiceId !== null && invoiceId !== undefined && lineItemId !== null && lineItemId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listInvoiceCosts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListInvoiceCostsQueryResult = NonNullable<Awaited<ReturnType<typeof listInvoiceCosts>>>
export type ListInvoiceCostsQueryError = ErrorType<unknown>


/**
 * @summary List internal costs for an invoice line item
 */

export function useListInvoiceCosts<TData = Awaited<ReturnType<typeof listInvoiceCosts>>, TError = ErrorType<unknown>>(
 invoiceId: number,
    lineItemId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listInvoiceCosts>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListInvoiceCostsQueryOptions(invoiceId,lineItemId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateInvoiceCostUrl = (invoiceId: number,
    lineItemId: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${lineItemId}/costs`
}

/**
 * @summary Add an internal cost to an invoice line item
 */
export const createInvoiceCost = async (invoiceId: number,
    lineItemId: number,
    createMaterialBody: CreateMaterialBody, options?: RequestInit): Promise<Material> => {

  return customFetch<Material>(getCreateInvoiceCostUrl(invoiceId,lineItemId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMaterialBody)
  }
);}




export const getCreateInvoiceCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext> => {

const mutationKey = ['createInvoiceCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createInvoiceCost>>, {invoiceId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}> = (props) => {
          const {invoiceId,lineItemId,data} = props ?? {};

          return  createInvoiceCost(invoiceId,lineItemId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateInvoiceCostMutationResult = NonNullable<Awaited<ReturnType<typeof createInvoiceCost>>>
    export type CreateInvoiceCostMutationBody = BodyType<CreateMaterialBody>
    export type CreateInvoiceCostMutationError = ErrorType<unknown>

    /**
 * @summary Add an internal cost to an invoice line item
 */
export const useCreateInvoiceCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createInvoiceCost>>,
        TError,
        {invoiceId: number;lineItemId: number;data: BodyType<CreateMaterialBody>},
        TContext
      > => {
      return useMutation(getCreateInvoiceCostMutationOptions(options));
    }

export const getUpdateInvoiceCostUrl = (invoiceId: number,
    lineItemId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${lineItemId}/costs/${id}`
}

/**
 * @summary Update an internal cost for an invoice line item
 */
export const updateInvoiceCost = async (invoiceId: number,
    lineItemId: number,
    id: number,
    createMaterialBody: CreateMaterialBody, options?: RequestInit): Promise<Material> => {

  return customFetch<Material>(getUpdateInvoiceCostUrl(invoiceId,lineItemId,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createMaterialBody)
  }
);}




export const getUpdateInvoiceCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext> => {

const mutationKey = ['updateInvoiceCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateInvoiceCost>>, {invoiceId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}> = (props) => {
          const {invoiceId,lineItemId,id,data} = props ?? {};

          return  updateInvoiceCost(invoiceId,lineItemId,id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateInvoiceCostMutationResult = NonNullable<Awaited<ReturnType<typeof updateInvoiceCost>>>
    export type UpdateInvoiceCostMutationBody = BodyType<CreateMaterialBody>
    export type UpdateInvoiceCostMutationError = ErrorType<unknown>

    /**
 * @summary Update an internal cost for an invoice line item
 */
export const useUpdateInvoiceCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateInvoiceCost>>,
        TError,
        {invoiceId: number;lineItemId: number;id: number;data: BodyType<CreateMaterialBody>},
        TContext
      > => {
      return useMutation(getUpdateInvoiceCostMutationOptions(options));
    }

export const getDeleteInvoiceCostUrl = (invoiceId: number,
    lineItemId: number,
    id: number,) => {




  return `/api/invoices/${invoiceId}/line-items/${lineItemId}/costs/${id}`
}

/**
 * @summary Delete an internal cost for an invoice line item
 */
export const deleteInvoiceCost = async (invoiceId: number,
    lineItemId: number,
    id: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteInvoiceCostUrl(invoiceId,lineItemId,id),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteInvoiceCostMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number}, TContext> => {

const mutationKey = ['deleteInvoiceCost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoiceCost>>, {invoiceId: number;lineItemId: number;id: number}> = (props) => {
          const {invoiceId,lineItemId,id} = props ?? {};

          return  deleteInvoiceCost(invoiceId,lineItemId,id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoiceCostMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoiceCost>>>

    export type DeleteInvoiceCostMutationError = ErrorType<unknown>

    /**
 * @summary Delete an internal cost for an invoice line item
 */
export const useDeleteInvoiceCost = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoiceCost>>, TError,{invoiceId: number;lineItemId: number;id: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoiceCost>>,
        TError,
        {invoiceId: number;lineItemId: number;id: number},
        TContext
      > => {
      return useMutation(getDeleteInvoiceCostMutationOptions(options));
    }

export const getGetInvoiceDashboardSummaryUrl = (params?: GetInvoiceDashboardSummaryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/dashboard/summary?${stringifiedParams}` : `/api/invoices/dashboard/summary`
}

/**
 * @summary Get invoice dashboard summary stats
 */
export const getInvoiceDashboardSummary = async (params?: GetInvoiceDashboardSummaryParams, options?: RequestInit): Promise<InvoiceDashboardSummary> => {

  return customFetch<InvoiceDashboardSummary>(getGetInvoiceDashboardSummaryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoiceDashboardSummaryQueryKey = (params?: GetInvoiceDashboardSummaryParams,) => {
    return [
    `/api/invoices/dashboard/summary`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInvoiceDashboardSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceDashboardSummary>>, TError = ErrorType<unknown>>(params?: GetInvoiceDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceDashboardSummaryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceDashboardSummary>>> = ({ signal }) => getInvoiceDashboardSummary(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardSummary>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceDashboardSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceDashboardSummary>>>
export type GetInvoiceDashboardSummaryQueryError = ErrorType<unknown>


/**
 * @summary Get invoice dashboard summary stats
 */

export function useGetInvoiceDashboardSummary<TData = Awaited<ReturnType<typeof getInvoiceDashboardSummary>>, TError = ErrorType<unknown>>(
 params?: GetInvoiceDashboardSummaryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardSummary>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInvoiceDashboardSummaryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetInvoiceDashboardRevenueByCategoryUrl = (params?: GetInvoiceDashboardRevenueByCategoryParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/invoices/dashboard/revenue-by-category?${stringifiedParams}` : `/api/invoices/dashboard/revenue-by-category`
}

/**
 * @summary Get invoice revenue broken down by product category
 */
export const getInvoiceDashboardRevenueByCategory = async (params?: GetInvoiceDashboardRevenueByCategoryParams, options?: RequestInit): Promise<InvoiceRevenueByCategoryItem[]> => {

  return customFetch<InvoiceRevenueByCategoryItem[]>(getGetInvoiceDashboardRevenueByCategoryUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetInvoiceDashboardRevenueByCategoryQueryKey = (params?: GetInvoiceDashboardRevenueByCategoryParams,) => {
    return [
    `/api/invoices/dashboard/revenue-by-category`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetInvoiceDashboardRevenueByCategoryQueryOptions = <TData = Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>, TError = ErrorType<unknown>>(params?: GetInvoiceDashboardRevenueByCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoiceDashboardRevenueByCategoryQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>> = ({ signal }) => getInvoiceDashboardRevenueByCategory(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInvoiceDashboardRevenueByCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>>
export type GetInvoiceDashboardRevenueByCategoryQueryError = ErrorType<unknown>


/**
 * @summary Get invoice revenue broken down by product category
 */

export function useGetInvoiceDashboardRevenueByCategory<TData = Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>, TError = ErrorType<unknown>>(
 params?: GetInvoiceDashboardRevenueByCategoryParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInvoiceDashboardRevenueByCategory>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInvoiceDashboardRevenueByCategoryQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







